  import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
  import { useParams, withRouter } from 'react-router-dom';
  import { useDispatch, useSelector } from 'react-redux';
  import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    MenuItem,
    Select,
    TextField,
    Divider,
    Checkbox,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Menu, FormControlLabel, Switch
  } from '@mui/material';
  import AttachmentIcon from '@mui/icons-material/Attachment';
  import EnhancedTextArea from '@common/components/EnhancedTextArea';

  import styles from './styles.module.scss';
  import './styles.global.scss';

  import { getAllowedJourneysWithDebounce, getJourney } from '@journeys/sagas';
  import { getAddressSuggestionsWithDebounce, getLendProvidersWithDebounce } from '@registration/sagas';
  import history from '@utils/history';
  import { getJourneyDetailsPath } from '@utils/getJourneyDetailsPath';
  import HeaderedPageLayout from '@common/components/HeaderedPageLayout';
  import { displayErrorMessage } from '@utils/displayErrorMessage';
  import { clearTimeTrackingInLocalStorage, convertTimeToLocalHours, getElapsedTimeMinutes } from '@utils/helpers';
  import { getUserRole, isAllowedByRoles, isJustDataOperations, USER_ROLE } from '@utils/authorisation';
  import {
    createCase,
    createCaseTimeLog,
    deleteCaseTimeLog,
    getAndUpdateEditors,
    getCase,
    getCaseTimeLogs,
    getCaseTypes,
    updateCase, updateCaseTimeLog
  } from '../../sagas';
  import { getAllowedUsersWithDebounce, getSpecialists } from '@user/sagas';
  import ValidationErrorLabel from '@common/components/ValidationErrorLabel';
  import AdapterDateFns from '@mui/lab/AdapterDateFns';
  import auLocale from 'date-fns/locale/en-AU';
  import LocalizationProvider from '@mui/lab/LocalizationProvider';
  import { DateTimePicker } from '@mui/lab';
  import AttachFilesModal from '@documents/components/AttachFilesModal';
  import {
    createDocument,
    deleteDocuments,
    getDocuments,
    getDocumentsByIds,
    getDocumentTypes,
    updateDocument,
    uploadDocumentFiles,
    uploadDocumentOriginalFiles
  } from '@documents/sagas';
  import { downloadFile, downloadOriginalFile, removeDocumentFile } from '@documents/sagas';
  import { differenceInMinutes, format } from 'date-fns';
  import ErrorIcon from '@mui/icons-material/Error';
  import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
  import ConfirmDeletionModal from '@common/components/ConfirmDeletionModal';
  import { deepClone } from '@utils/deepClone';
  import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
  import AvTimerIcon from '@mui/icons-material/AvTimer';
  import PlayArrowIcon from '@mui/icons-material/PlayArrow';
  import StopIcon from '@mui/icons-material/Stop';
  import IconButton from '@mui/material/IconButton';
  import MoreVertIcon from '@mui/icons-material/MoreVert';
  import EditIcon from '@mui/icons-material/Edit';
  import CloseIcon from '@mui/icons-material/Close';
  import SaveIcon from '@mui/icons-material/Save';
  import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
  import VisibilityIcon from '@mui/icons-material/Visibility';
  import queryString from 'query-string';
  import axios from 'axios';
  //import { displayNotification } from '@utils/snackbarUtils';
  import EnhancedTinyMCEditor from '@common/components/EnhancedTinyMCEditor';
  import ValidatedTextInput from '@common/components/ValidatedTextInput';
  import ProvideElapsedTimeModal from '@common/components/ProvideElapsedTimeModal';
  import RadioButtonGroup from '@common/components/RadioButtonGroup';
  import DollarAmountFormat from '@common/components/DollarAmountFormat';
  import PercentageFormat from '@common/components/PercentageFormat';
  import InputWithSelect from '@common/components/InputWithSelect';
  import PositiveIntegerFormat from '@common/components/PositiveIntegerFormat';
  import Tooltip from "@common/components/Tooltip";
  import { closeHintsOnClick } from '@utils/closeHintsOnClick';
  import docUploadStyles from '@documents/components/DocumentsUpload/styles.module.scss';
  import { getFileTypeObject, isFilePreviewSupported } from '@utils/helpers';
  import config from '@src/config';


  const OTHER = 'Other';
  const ACTIONS_STATUSES = [
    'IN PROGRESS',
    'COMPLETED',
    'ON HOLD'
  ];
  const ACTIONS_STATUSES_CREATION = [
    'IN PROGRESS',
    'ON HOLD'
  ];
  const HISTORY_FILTERS = [
    'COMMENTS',
    'DOCUMENTS',
    'ALL'
  ];
  const MAX_NOTES_SIZE = 2 * 1024 * 1024;
  const ACTION_TYPES_WITH_DEFAULT_SETTLEMENTS_COORDINATOR_ASSIGNEE = [
    'follow_up_with_the_customer',
    'post_assessment_data_reviewed',
    'prepare_for_settlement'
  ];
  const PREPARE_PRICING_ALLOWED_ROLES = [USER_ROLE.Admin, USER_ROLE.Specialist];
  const ACTION_PERMISSION_ERROR = 'You don\'t have a permission to create this type of actions';

  let intervalId;
  let timerCheckIntervalId;
  let checkBoxUpdateTimeoutId;
  let propertyValuationUpdateTimeoutId;
  let preparePricingUpdateTimeoutId;

  const isAddressCustom = (address) => {
    if (!address) return false;
    const keys = Object.keys(address).filter(key => address[key] !== null && address[key] !== undefined && address[key] !== '');
    return keys.length <= 2 && keys.includes('fullAddress') && (keys.includes('country') || keys.length === 1);
  };

  const FormRow = ({ label, children, alignTop = false }) => (
    <Grid container justifyContent={'space-between'} alignItems={alignTop ? 'flex-start' : 'center'} style={{ marginBottom: '16px' }}>
      <Grid item className={styles.info} xs={12} sm={6} style={{ paddingTop: alignTop ? '10px' : '0' }}>
        {label}
      </Grid>
      <Grid item xs={12} sm={6}>
        {children}
      </Grid>
    </Grid>
  );

  const CaseForm = ({ location }) => {
    const dimensions = useSelector(state => state.dimensions);
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    const { journeyId, source } = queryString.parse(location.search);
    const { configParameters } = useSelector(state => state.configParameters);

    const { caseId } = useParams();
    const [nextDisabled, setNextDisabled] = useState(true);
    const [inProgress, setInProgress] = useState(false);
    const [actionType, setActionType] = useState('');
    const [actionTypeOptions, setActionTypeOptions] = useState([]);
    const [customActionTypeOptions, setCustomActionTypeOptions] = useState([]);
    const [journeyOwner, setJourneyOwner] = useState(undefined);
    const [journeyOwnerOptions, setJourneyOwnerOptions] = useState([]);
    const [journeySearchString, setJourneySearchString] = useState('');
    const [journey, setJourney] = useState(undefined);
    const [journeyOptions, setJourneyOptions] = useState([]);
    const [actionStatus, setActionStatus] = useState('IN PROGRESS');
    const [userRole, setUserRole] = useState(undefined);
    const [effectiveUser, setEffectiveUser] = useState(undefined);
    const [currentActionState, setCurrentActionState] = useState(undefined);
    const [isUpdatingJourneys, setIsUpdatingJourneys] = useState(false);
    const [reason, setReason] = useState('');
    const [remindTime, setRemindTime] = useState(null);
    const [isWaitingOnHoldParameters, setIsWaitingOnHoldParameters] = useState(false);

    const [newHistory, setNewHistory] = useState([]);
    const [oldHistory, setOldHistory] = useState([]);
    const [assignedTo, setAssignedTo] = useState(null);
    const [assigneeOptions, setAssigneeOptions] = useState([]);
    const [reviewedJourneyDocuments, setReviewedJourneyDocuments] = useState([]);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [currentEditors, setCurrentEditors] = useState([]);
    const [urgent, setUrgent] = useState(false);

    const [notesHtml, setNotesHtml] = useState('');
    const [shouldUpdateTinyEditor, setShouldUpdateTinyEditor] = useState(false);
    const [isEditingNotes, setIsEditingNotes] = useState(false);
    const [notesBeforeEditing, setNotesBeforeEditing] = useState('');

    const [commentHtml, setCommentHtml] = useState('');
    const [shouldUpdateCommentEditor, setShouldUpdateCommentEditor] = useState(false);
    const [isEditingComment, setIsEditingComment] = useState(false);

    const [description, setDescription] = useState('');
    const [checklist, setChecklist] = useState([]);
    const [groupedChecklist, setGroupedChecklist] = useState([]);
    const [timeLogs, setTimeLogs] = useState([]);
    const [aggregatedTimeLogs, setAggregatedTimeLogs] = useState([]);
    const [isLogsLoading, setIsLogsLoading] = useState(true);
    const [historyFilter, setHistoryFilter] = useState('COMMENTS');

    const [touchedInputs, setTouchedInputs] = useState(-1);
    const [touchedPricingInputs, setTouchedPricingInputs] = useState([]);
    const [createTimeLogOpen, setCreateTimeLogOpen] = useState(false);
    const [createTimeLogParameters, setCreateTimeLogParameters] = useState({});
    const [currentProgress, setCurrentProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [openAttachFiles, setOpenAttachFiles] = useState(false);
    const [documentTypes, setDocumentTypes] = useState(undefined);
    const [documentToView, setDocumentToView] = useState(undefined);
    const [purpose, setPurpose] = useState('create');//create|view
    const [limitationMode, setLimitationMode] = useState('actionDocument');
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [deleteConfirmationParameters, setDeleteConfirmationParameters] = useState({});
    const [actionMenuPosition, setActionMenuPosition] = useState(null);
    const [actionLogId, setActionLogId] = useState(null);
    const [activeTimeTracker, setActiveTimeTracker] = useState(undefined);
    const [userTracking, setUserTracking] = useState(undefined);
    const [prevActiveTimeTracker, setPrevActiveTimeTracker] = useState(undefined);

    const [isChecklistProcessing, setIsChecklistProcessing] = useState(false);
    const [SLABreachedTooltip, setSLABreachedTooltip] = useState(null);
    const [queueSLABreachedTooltip, setQueueSLABreachedTooltip] = useState(null);
    const [isPropertyValuationProcessing, setIsPropertyValuationProcessing] = useState(false);

    const [propertyAddress, setPropertyAddress] = useState(undefined);
    const [propertyAddressInput, setPropertyAddressInput] = useState('');
    const [addressOptions, setAddressOptions] = useState([]);
    const [isCustomAddress, setIsCustomAddress] = useState(false);
    const [selectedLender, setSelectedLender] = useState(undefined);
    const [lenderOptions, setLenderOptions] = useState([]);
    const [noLenderOptionsText, setNoLenderOptionsText] = useState('Start typing to search');
    const [isLoadingPropertyValuationData, setIsLoadingPropertyValuationData] = useState(false);

    const [pricingLoanPurpose, setPricingLoanPurpose] = useState('');
    const [pricingEstimatedPrice, setPricingEstimatedPrice] = useState('');
    const [pricingLoanAmount, setPricingLoanAmount] = useState('');
    const [pricingDeposit, setPricingDeposit] = useState('');
    const [pricingFirstHomeBuyer, setPricingFirstHomeBuyer] = useState('');
    const [pricingReasonToBuy, setPricingReasonToBuy] = useState('');
    const [pricingRateType, setPricingRateType] = useState('');
    const [pricingFixedRateTerm, setPricingFixedRateTerm] = useState('');
    const [pricingRepaymentType, setPricingRepaymentType] = useState('');
    const [pricingLoanTermValue, setPricingLoanTermValue] = useState('');
    const [pricingLoanTermUnit, setPricingLoanTermUnit] = useState('years');
    const [pricingSelectedLenders, setPricingSelectedLenders] = useState([]);
    const [isLoadingPreparePricingData, setIsLoadingPreparePricingData] = useState(false);
    const [activeHint, setActiveHint] = useState(''); // RateType|FixedRateTerm
    const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productAttachModalOpen, setProductAttachModalOpen] = useState(false);
    const [productAttachDocument, setProductAttachDocument] = useState(undefined);
    const [productAttachPurpose, setProductAttachPurpose] = useState('create');
    const [productAttachDocumentTypes, setProductAttachDocumentTypes] = useState([]);
    const [activeProductId, setActiveProductId] = useState(null);
    const [loadedProductDocumentIds, setLoadedProductDocumentIds] = useState([]);
    const [showProductCompletionErrors, setShowProductCompletionErrors] = useState(false);
    const [valuationDocument, setValuationDocument] = useState(undefined);
    const [valuationAttachModalOpen, setValuationAttachModalOpen] = useState(false);
    const [valuationDocumentTypes, setValuationDocumentTypes] = useState([]);

    const PREPARE_PRICING_UID = 'prepare_rates_research';
    const PROPERTY_VALUATION_UID = 'property_valuation';

    const PREPARE_PRICING_STORAGE_KEY = 'prepareRatesResearchInput';
    const PREPARE_PRICING_SELECTED_DEAL_KEY = 'prepareRatesResearchSelectedDeal';

    const currentActionStateRef = useRef(undefined);
    const assigneeOptionsRef = useRef([]);
    const hasRestoredPrepareRatesPayloadRef = useRef(false);
    const journeyRestoreInFlightRef = useRef(false);

    const propertyAddressRef = useRef(undefined);
    const pricingLoanPurposeRef = useRef('');
    const pricingEstimatedPriceRef = useRef('');
    const pricingLoanAmountRef = useRef('');
    const pricingDepositRef = useRef('');
    const pricingFirstHomeBuyerRef = useRef('');
    const pricingReasonToBuyRef = useRef('');
    const pricingRateTypeRef = useRef('');
    const pricingFixedRateTermRef = useRef('');
    const pricingRepaymentTypeRef = useRef('');
    const pricingLoanTermValueRef = useRef('');
  const pricingLoanTermUnitRef = useRef('years');
  const pricingSelectedLendersRef = useRef([]);
  const selectedProductsRef = useRef([]);
  const lastPrepPricingLogRef = useRef('');

  const isPrepareRatesType = (actionType?.uid === PREPARE_PRICING_UID) || (currentActionState?.typeObj?.uid === PREPARE_PRICING_UID);
  const isPropertyValuationType = (actionType?.uid === PROPERTY_VALUATION_UID) || (currentActionState?.typeObj?.uid === PROPERTY_VALUATION_UID);
  const selectedActionType = (actionType && typeof actionType === 'object' && Object.keys(actionType).length)
    ? actionType
    : (currentActionState?.typeObj ?? {});
  const actionHasPropertyAddressField = !!selectedActionType.hasPropertyAddressField;
  const actionHasValuationFileField = !!selectedActionType.hasValuationFileField;
  const actionHasLenderField = !!selectedActionType.hasLenderField;
  const actionHasDealPricingFields = !!selectedActionType.hasDealPricingFields;
  const actionHasFinancialAssessmentFields = !!selectedActionType.hasFinancialAssessmentFields;
  const actionHasDealLendersField = !!selectedActionType.hasDealLendersField;
  const actionHasFinancialFields = actionHasDealPricingFields || actionHasFinancialAssessmentFields;
  const actionHasDealFinderFields = actionHasFinancialFields || actionHasDealLendersField;

    const getEnrichedTypeObj = (typeObj) => {
      if (!typeObj) return typeObj;
      const allTypes = [...(actionTypeOptions ?? []), ...(customActionTypeOptions ?? [])];
      const matched = allTypes.find((t) => t.uid === typeObj.uid || t.id === typeObj.id || t._id === typeObj.id || t._id === typeObj._id);
      return matched ? { ...matched, ...typeObj } : typeObj;
    };
    const isActionCompleted = !!caseId && actionStatus === 'COMPLETED';
    const isCreateMode = !caseId;
    const shouldShowLenderField = actionHasLenderField;
    const hasFinancialAssessmentFields = actionHasFinancialAssessmentFields;
    const disableLenderApprovalUpload = isCreateMode && hasFinancialAssessmentFields;
    const disableFinalDiscountedRate = isCreateMode && hasFinancialAssessmentFields;
    const areProductsDisabled = inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData || isUploading || isActionCompleted;

    const isPreparePricingActionSelected = isPrepareRatesType;
    const isPreparePricingCreationRestricted = !caseId && isPreparePricingActionSelected && !isAllowedByRoles(user, PREPARE_PRICING_ALLOWED_ROLES);

    const returnBack = () => {
      const target = source === 'journey-details'
        ? `${getJourneyDetailsPath(journey ?? currentActionState?.journey, journeyId)}?milestone=Summary`
        : `/${source ?? 'dashboard'}${!!journeyId ? `/${journeyId}` : ''}`;
      history.push(target);
    };

    useEffect(() => {
      const enrichNames = (type) => {
        const enrichedName = `${type.category ?? '-'} / ${type.name}`;
        return { ...type, enrichedName }
      };
      const sortByEnrichedName = (a, b) => {
        return a.enrichedName.localeCompare(b.enrichedName)
      };

      dispatch(getCaseTypes({
        onSuccess: (data) => {
          setActionTypeOptions((data ?? []).filter((type) => !type.custom && ![
            'background_report',
            'backchannel_unmapped',
            'backchannel_info',
            'journey_withdrawn',
            'settled',
            'assessment_data_reviewed',
            'property_valuation',
            'review_post_assessment_data',
            'post_assessment_data_reviewed',
            'prepare_for_settlement',
            'loandocs_verified_by_lender',
            'loan_docs_preparation',
            'loan_docs_sent',
            'loan_docs_received'
          ].includes(type.uid) && (!['prepare_rates_research'].includes(type.uid) || isAllowedByRoles(user, [USER_ROLE.Specialist, USER_ROLE.Admin])))
            .map(enrichNames)
            .sort(sortByEnrichedName)
          );
          setCustomActionTypeOptions((data ?? []).filter((type) => !!type.custom).map(enrichNames).sort(sortByEnrichedName));
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve action types');
        }
      }));

      dispatch(getSpecialists({
        onSuccess: (data) => {
          setAssigneeOptions(data.elements ?? []);
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve specialists');
        }
      }));

      dispatch(getDocumentTypes({
        onSuccess: (data) => {
          setDocumentTypes(data);
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to get document types');
        }
      }));

      checkCurrentEditors();

      setActiveTimeTracker(localStorage.getItem('timeTrackingAction') ?? undefined);
      setUserTracking(localStorage.getItem('timeTrackingUser') ?? undefined);

      intervalId = setInterval(() => {
        setCurrentTime(new Date());
        if (!!caseId) {
          checkAndUpdateAction();
          checkCurrentEditors();
        }
      }, 20000);

      timerCheckIntervalId = setInterval(() => {
        setActiveTimeTracker(localStorage.getItem('timeTrackingAction') ?? undefined);
        setUserTracking(localStorage.getItem('timeTrackingUser') ?? undefined);
      }, 400);

      return () => {
        if (intervalId) clearInterval(intervalId);
        if (timerCheckIntervalId) clearInterval(timerCheckIntervalId);
      };
    }, []);//eslint-disable-line

    useEffect(() => {
      if ((!!activeTimeTracker || !!prevActiveTimeTracker) && activeTimeTracker !== prevActiveTimeTracker) {
        setTimeout(() => {
          setIsLogsLoading(true);
          if (caseId) {
            dispatch(getCaseTimeLogs({
              caseId,
              onSuccess: (data) => {
                setTimeLogs(data);
                setIsLogsLoading(false);
              },
              onError: (data) => {
                displayErrorMessage(data, 'Unable to retrieve action\'s time logs');
                setIsLogsLoading(false);
              }
            }));
          }
        }, 2000);
      }

      setPrevActiveTimeTracker(activeTimeTracker);
    }, [activeTimeTracker, prevActiveTimeTracker]);//eslint-disable-line

    useEffect(() => {
      setIsWaitingOnHoldParameters(actionStatus === 'ON HOLD' && (!reason || !remindTime));
    }, [reason, remindTime, actionStatus]); //eslint-disable-line

    useLayoutEffect(() => {
      closeHintsOnClick(activeHint, setActiveHint);
    }, [activeHint, setActiveHint]); //eslint-disable-line

    useEffect(() => {
      if (isJustDataOperations(user)) history.push('/deals-management');

      setUserRole(getUserRole(user));
      setEffectiveUser(user);
    }, [user]);//eslint-disable-line


    useEffect(() => {
      if (assigneeOptions?.length) {
        assigneeOptionsRef.current = assigneeOptions;
        if (caseId) {
          dispatch(getCase({
            id: caseId,
            onSuccess: (actionData) => {
              const enrichedTypeObj = getEnrichedTypeObj(actionData?.typeObj);
              setCurrentActionState(enrichedTypeObj ? { ...actionData, typeObj: enrichedTypeObj } : actionData);
              setAssignedTo(assigneeOptions.find((option) => option.id === actionData.assignee?.id) ?? null);
              setActionStatus(actionData.caseStatus);
              setOldHistory(actionData.history ?? []);
              setNewHistory([]);
              setJourney(actionData?.journey);
              setJourneyOwner(actionData?.journey?.user);
              setUrgent(!!actionData?.urgent);
              if (actionData.typeObj?.custom) setDescription(actionData?.description ?? '');

              if (actionData.propertyAddress) {
                setPropertyAddress(actionData.propertyAddress);
                setPropertyAddressInput(actionData.propertyAddress.fullAddress || '');
                setIsCustomAddress(isAddressCustom(actionData.propertyAddress));
              }
              if (actionData.lender) setSelectedLender(actionData.lender);

              if (actionData.valuationDocument) {
                 setValuationDocument(normalizeProductDocument(actionData.valuationDocument));
              }

              if (actionData.notes) {
                setNotesHtml(actionData.notes);
                setShouldUpdateTinyEditor(true);
              } else {
                setShouldUpdateTinyEditor(false);
              }

              if (!actionData.checklist?.length) {
                setChecklist([]);
                setGroupedChecklist([]);
              } else {
                const formattedChecklist = actionData.checklist.map((item) => {
                  const itemTypeObject = actionData.typeObj?.checklist.find((it) => it.uid === item.uid);
                  return { ...item, title: itemTypeObject?.title, section: itemTypeObject?.section };
                });

                let newGroupedCheckList = [];
                let otherItems = { section: OTHER, items: [] };
                formattedChecklist.forEach((it) => {
                  const { section, ...rest } = it;
                  const sectionTitle = !!(section?.trim()) ? section : OTHER;

                  if (sectionTitle === OTHER) {
                    otherItems.items.push(rest);
                  } else {
                    const sectionIndex = newGroupedCheckList.findIndex((group) => group.section === section);
                    if (sectionIndex < 0) {
                      newGroupedCheckList.push({ section, items: [rest] });
                    } else {
                      newGroupedCheckList[sectionIndex].items.push(rest);
                    }
                  }

                });
                if (otherItems.items.length) newGroupedCheckList.push(otherItems);

                setGroupedChecklist(newGroupedCheckList);
                setChecklist(formattedChecklist);
              }

              setIsLogsLoading(true);
              dispatch(getCaseTimeLogs({
                caseId,
                onSuccess: (timeLogsData) => {
                  setTimeLogs(timeLogsData);
                  setIsLogsLoading(false);

                  if (!!actionData.journey) {
                    dispatch(getDocuments({
                      journeyId: actionData.journey.id,
                      statuses: ['Reviewed'],
                      onSuccess: (documentsData) => {
                        setReviewedJourneyDocuments(documentsData?.elements ?? []);
                      },
                      onError: (data) => {
                        displayErrorMessage(data, 'Unable to retrieve journey\'s documents');
                      }
                    }));
                  } else {
                    const ids = (actionData.history ?? []).map((it) => it?.meta?.document).filter(Boolean);

                    if (!!ids.length) {
                      dispatch(getDocumentsByIds({
                        documentIds: ids,
                        onSuccess: (documentsData) => {
                          setReviewedJourneyDocuments(documentsData ?? []);
                          setInProgress(false);
                        },
                        onError: (data) => {
                          displayErrorMessage(data, 'Unable to retrieve documents');
                        }
                      }));
                    } else {
                      setInProgress(false);
                    }
                  }

                  if (actionData.valuationDocument) {
                    const vDocId = getDocumentIdFromValue(actionData.valuationDocument);
                    if (vDocId) {
                      dispatch(getDocumentsByIds({
                        documentIds: [vDocId],
                        onSuccess: (docs) => {
                          if (docs && docs.length > 0) {
                            setValuationDocument(normalizeProductDocument(docs[0]));
                          }
                        },
                        onError: () => {}
                      }));
                    }
                  }

                },
                onError: (data) => {
                  displayErrorMessage(data, 'Unable to retrieve action\'s time logs');
                  setIsLogsLoading(false);
                }
              }));
            },
            onError: (data) => {
              displayErrorMessage(data, 'Unable to retrieve action');
            }
          }));
        } else {
          setCurrentActionState(undefined);
        }
      }
    }, [caseId, assigneeOptions]);//eslint-disable-line

    useEffect(() => {
      if (!currentActionState?.typeObj) return;

      const enrichedTypeObj = getEnrichedTypeObj(currentActionState.typeObj);
      if (!enrichedTypeObj) return;

      const fieldsToBackfill = [
        'hasPropertyAddressField',
        'hasValuationFileField',
        'hasFinancialAssessmentFields',
        'hasDealPricingFields',
        'hasDealLendersField',
        'hasLenderField',
        'maxLenders'
      ];

      const needsBackfill = fieldsToBackfill.some((key) => {
        if (currentActionState.typeObj[key] === undefined && enrichedTypeObj[key] !== undefined) return true;
        if (key === 'maxLenders' && enrichedTypeObj[key] !== undefined && enrichedTypeObj[key] !== currentActionState.typeObj[key]) return true;
        return false;
      });
      if (needsBackfill) {
        setCurrentActionState((prev) => prev ? { ...prev, typeObj: { ...prev.typeObj, ...enrichedTypeObj } } : prev);
      }
    }, [actionTypeOptions, customActionTypeOptions, currentActionState?.typeObj]); //eslint-disable-line

    useEffect(() => {
      if (journeyId) {
        dispatch(getJourney({
          id: journeyId,
          onSuccess: (data) => {
            setJourney(data);
            setJourneyOwner(data.user)
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve the journey');
          }
        }));
      }
    }, [journeyId]);//eslint-disable-line

    useEffect(() => {
      // eslint-disable-next-line no-console
      dispatch(getAllowedJourneysWithDebounce({
        limit: 100,
        userId: journeyOwner?._id,
        search: !!journeySearchString ? journeySearchString : undefined,
        onSuccess: (data) => {
          setJourneyOptions(data?.elements ?? []);
          setIsUpdatingJourneys(false);
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve the journeys number');
          setIsUpdatingJourneys(false);
        }
      }))
    }, [journeyOwner, journeySearchString]);//eslint-disable-line

    useEffect(() => {
      if (journey) {
        setJourneySearchString('');
      }
    }, [journey]); //eslint-disable-line

    useEffect(() => {
      syncSelectedDealFromStorage();
      const handleStorage = (event) => {
        if (event.key === PREPARE_PRICING_SELECTED_DEAL_KEY && event.newValue) {
          syncSelectedDealFromStorage();
        }
      };
      window.addEventListener('storage', handleStorage);
      return () => window.removeEventListener('storage', handleStorage);
    }, []); //eslint-disable-line

    useEffect(() => {
      if (userRole === USER_ROLE.Customer) returnBack();
    }, [userRole]); //eslint-disable-line

    useEffect(() => {
      // restore prepare rates data and draft selections after returning from Deal Finder
      if (caseId || source !== 'prepare_rates_research') {
        // eslint-disable-next-line no-console
        return;
      }
      if (hasRestoredPrepareRatesPayloadRef.current) return;

      let stored = null;
      try {
        const raw = localStorage.getItem(PREPARE_PRICING_STORAGE_KEY);
        if (!raw) {
          // eslint-disable-next-line no-console
          return;
        }

        stored = JSON.parse(raw);

        const currentRelativeUrl = `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;
        if (stored?.returnUrl && stored.returnUrl !== window.location.href && stored.returnUrl !== currentRelativeUrl) {
          // eslint-disable-next-line no-console
          return;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[prepare-rates][CaseForm] Unable to restore prepare pricing payload', error);
        return;
      }

      // eslint-disable-next-line no-console

      let isPending = false;

      if (!actionType?.uid && stored?.actionTypeUid) {
        const allTypes = [...(actionTypeOptions ?? []), ...(customActionTypeOptions ?? [])];
        if (!allTypes.length) {
          isPending = true;
        } else {
          const foundType = allTypes.find((t) => t.uid === stored.actionTypeUid);
          if (foundType) setActionType(foundType);
        }
      }

      if (!journey?.id && stored?.journeyId && !journeyRestoreInFlightRef.current) {
        journeyRestoreInFlightRef.current = true;
        dispatch(getJourney({
          id: stored.journeyId,
          onSuccess: (data) => {
            setJourney(data);
            setJourneyOwner(data.user);
            journeyRestoreInFlightRef.current = false;
            // eslint-disable-next-line no-console
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve journey details');
            journeyRestoreInFlightRef.current = false;
          }
        }));
        isPending = true;
      }

      if (!journeyOwner && stored?.journeyOwnerId && journey?.user) {
        setJourneyOwner(journey.user);
      }
      if (!journeyOwner && stored?.journeyOwnerId && !journey?.user) {
        const placeholderOwner = {
          id: stored.journeyOwnerId,
          name: stored.journeyOwnerName,
          surname: stored.journeyOwnerSurname
        };
        setJourneyOwner(placeholderOwner);
        setJourneyOwnerOptions((prev = []) => {
          const exists = prev.find((o) => o.id === placeholderOwner.id);
          return exists ? prev : [placeholderOwner, ...prev];
        });
      }

      if (!journey?.id && stored?.journeyId) {
        const placeholderJourney = { id: stored.journeyId, name: stored.journeyName ?? 'Restored journey' };
        setJourney(placeholderJourney);
        setJourneyOptions((prev = []) => {
          const exists = prev.find((j) => j.id === placeholderJourney.id);
          return exists ? prev : [placeholderJourney, ...prev];
        });
      }

      if (!assignedTo && stored?.assignedToId) {
        if (!(assigneeOptions ?? []).length) {
          isPending = true;
        } else {
          const foundAssignee = assigneeOptions.find((option) => option.id === stored.assignedToId);
          if (foundAssignee) setAssignedTo(foundAssignee);
        }
      }

      if (stored?.loanPurpose) setPricingLoanPurpose(stored.loanPurpose);
      if (stored?.estimatedPrice) setPricingEstimatedPrice(String(stored.estimatedPrice));
      if (stored?.loanAmount) setPricingLoanAmount(String(stored.loanAmount));
      if (stored?.deposit) setPricingDeposit(String(stored.deposit));
      if (stored?.firstHomeBuyer) setPricingFirstHomeBuyer(stored.firstHomeBuyer);
      if (stored?.reasonToBuy) setPricingReasonToBuy(stored.reasonToBuy);
      if (stored?.rateType) setPricingRateType(stored.rateType);
      if (stored?.fixedRateTerm) setPricingFixedRateTerm(stored.fixedRateTerm);
      if (stored?.repaymentType) setPricingRepaymentType(stored.repaymentType);
      if (stored?.loanTermValue) setPricingLoanTermValue(String(stored.loanTermValue));
      if (stored?.loanTermUnit) setPricingLoanTermUnit(stored.loanTermUnit);
      if (stored?.selectedLenderId) {
        const found = (lenderOptions ?? []).find((l) => l.id === stored.selectedLenderId || l._id === stored.selectedLenderId);
        if (found) setSelectedLender(found);
        else setSelectedLender({ id: stored.selectedLenderId, name: stored.selectedLenderName ?? '' });
      }

      if (stored?.propertyAddress) {
        setPropertyAddress(stored.propertyAddress);
        if (isAddressCustom(stored.propertyAddress)) {
          setIsCustomAddress(true);
          setPropertyAddressInput(stored.propertyAddress.fullAddress || '');
        } else {
          setPropertyAddressInput(stored.propertyAddress.fullAddress || '');
          setAddressOptions([stored.propertyAddress]);
        }
      }

      if (Array.isArray(stored?.selectedProducts) && stored.selectedProducts.length) {
        const mapped = stored.selectedProducts
          .map((deal, idx) => createSelectedProductFromPayload(deal, idx))
          .filter(Boolean);
        if (mapped.length) {
          setSelectedProducts((prev) => mergeProductsUnique(prev, mapped));
        }
      }

      if (typeof stored?.urgent === 'boolean') {
        setUrgent(stored.urgent);
      }

      if (!isPending) {
        hasRestoredPrepareRatesPayloadRef.current = true;
      }
    }, [actionType?.uid, caseId, actionTypeOptions, customActionTypeOptions, assigneeOptions, journey?.id, journeyOwner, source]); //eslint-disable-line

    useEffect(() => {
      //pre-fill when creating a new action
      if (!caseId && journey?.id && (actionHasPropertyAddressField || actionHasLenderField)) {
        setIsLoadingPropertyValuationData(true);
        dispatch(getJourney({
          id: journey.id,
          onSuccess: (data) => {
            setJourney(data);

            if (data?.assessment?.proposedLoan?.lender) {
              setSelectedLender(data.assessment.proposedLoan.lender);
            } else {
              setSelectedLender(undefined);
            }

            let addressToSet = null;

            if (data?.property?.address?.fullAddress) {
              addressToSet = data.property.address;
            }

            else if (data?.contracts?.length) {
              const formalApprovalContract = data.contracts.find(c => c.status === 'Active' || c.isCurrent);
              if (formalApprovalContract?.address?.fullAddress) {
                addressToSet = formalApprovalContract.address;
              }
            }

            if (!propertyAddress && addressToSet) {
              setPropertyAddress(addressToSet);
              setPropertyAddressInput(addressToSet.fullAddress || '');
            } else if (!propertyAddress && !addressToSet) {
              setPropertyAddress(undefined);
              setPropertyAddressInput('');
            }

            setIsLoadingPropertyValuationData(false);
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve journey details');
            setIsLoadingPropertyValuationData(false);
          }
        }));
      }
    }, [journey?.id, actionType?.hasPropertyAddressField, actionType?.hasLenderField, actionType?.uid, currentActionState?.typeObj?.hasPropertyAddressField, currentActionState?.typeObj?.hasLenderField, currentActionState?.typeObj?.uid, propertyAddress]); //eslint-disable-line

    useEffect(() => {
      //pre-fill when creating a new action for prepare_rates_research
      if (!caseId && journey?.id && (actionHasPropertyAddressField || actionHasFinancialFields || actionHasDealLendersField)) {
        setIsLoadingPreparePricingData(true);
        dispatch(getJourney({
          id: journey.id,
          onSuccess: (data) => {
            setJourney(data);

            let addressToSet = null;
            if (data?.property?.address?.fullAddress) {
              addressToSet = data.property.address;
            } else if (data?.contracts?.length) {
              const formalApprovalContract = data.contracts.find(c => c.status === 'Active' || c.isCurrent);
              if (formalApprovalContract?.address?.fullAddress) {
                addressToSet = formalApprovalContract.address;
              }
            }
            if (!propertyAddress && addressToSet) {
              setPropertyAddress(addressToSet);
              setPropertyAddressInput(addressToSet.fullAddress || '');
            }

            if (data?.userNeeds) {
              if (data.userNeeds.loanPurpose) setPricingLoanPurpose(data.userNeeds.loanPurpose);
              if (data.userNeeds.estimatedPrice) setPricingEstimatedPrice(String(data.userNeeds.estimatedPrice));
              if (data.userNeeds.loanAmount) setPricingLoanAmount(String(data.userNeeds.loanAmount));
              if (data.userNeeds.deposit) setPricingDeposit(String(data.userNeeds.deposit));
              if (data.userNeeds.firstHomeBuyer) setPricingFirstHomeBuyer(data.userNeeds.firstHomeBuyer);
              if (data.userNeeds.reasonToBuy) setPricingReasonToBuy(data.userNeeds.reasonToBuy);
              if (data.userNeeds.rateType) setPricingRateType(data.userNeeds.rateType);
              if (data.userNeeds.fixedRateTerm) setPricingFixedRateTerm(data.userNeeds.fixedRateTerm);
              if (data.userNeeds.repaymentType) setPricingRepaymentType(data.userNeeds.repaymentType);
              if (data.userNeeds.loanTermValue) setPricingLoanTermValue(String(data.userNeeds.loanTermValue));
              if (data.userNeeds.loanTermUnit) setPricingLoanTermUnit(data.userNeeds.loanTermUnit);
            }

            setIsLoadingPreparePricingData(false);
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve journey details');
            setIsLoadingPreparePricingData(false);
          }
        }));
      }
    }, [journey?.id, actionType?.hasPropertyAddressField, actionType?.hasDealPricingFields, actionType?.hasFinancialAssessmentFields, actionType?.hasDealLendersField, actionType?.uid, currentActionState?.typeObj?.hasPropertyAddressField, currentActionState?.typeObj?.hasDealPricingFields, currentActionState?.typeObj?.hasFinancialAssessmentFields, currentActionState?.typeObj?.hasDealLendersField, currentActionState?.typeObj?.uid, propertyAddress]); //eslint-disable-line

    useEffect(() => {
      if (actionType && !actionType.hasPropertyAddressField) {
        setPropertyAddress(undefined);
        setPropertyAddressInput('');
      }
      if (actionType && !actionType.hasLenderField) {
        setSelectedLender(undefined);
      }
      const actionTypeHasFinancialFields = actionType?.hasDealPricingFields || actionType?.hasFinancialAssessmentFields;
      if (actionType && !actionTypeHasFinancialFields) {
        setPricingLoanPurpose('');
        setPricingEstimatedPrice('');
        setPricingLoanAmount('');
        setPricingDeposit('');
        setPricingFirstHomeBuyer('');
        setPricingReasonToBuy('');
        setPricingRateType('');
        setPricingFixedRateTerm('');
        setPricingRepaymentType('');
        setPricingLoanTermValue('');
        setPricingLoanTermUnit('years');
      }
      if (actionType && !actionType.hasFinancialAssessmentFields) {
        setSelectedProducts([]);
      }
      if (actionType && !actionType.hasDealLendersField) {
        setPricingSelectedLenders([]);
      }
    }, [actionType]); //eslint-disable-line

    useEffect(() => {
      if (currentActionState) {
        if (actionHasPropertyAddressField) {
          // Load from preparePricing.propertyAddress when any deal finder fields are present, otherwise from root propertyAddress
          const addressToLoad = actionHasDealFinderFields
            ? currentActionState.preparePricing?.propertyAddress
            : currentActionState.propertyAddress;

          if (addressToLoad && !propertyAddress) {
            setPropertyAddress(addressToLoad);
            if (isAddressCustom(addressToLoad)) {
              setIsCustomAddress(true);
            } else {
              setPropertyAddressInput(addressToLoad.fullAddress || '');
              // Add the loaded address to options so it appears in dropdown
              setAddressOptions([addressToLoad]);
            }
          }
        }
        if (actionHasLenderField) {
          if (currentActionState.lender && !selectedLender) {
            setSelectedLender(currentActionState.lender);
          }
        }

        if (currentActionState.preparePricing) {
          const pp = currentActionState.preparePricing;
          const typeHasFinancialFields = actionHasFinancialFields;

          if (typeHasFinancialFields) {
            if (pp.loanPurpose && !pricingLoanPurpose) setPricingLoanPurpose(pp.loanPurpose);
            if (pp.estimatedPrice && !pricingEstimatedPrice) setPricingEstimatedPrice(String(pp.estimatedPrice));
            if (pp.loanAmount && !pricingLoanAmount) setPricingLoanAmount(String(pp.loanAmount));
            if (pp.deposit && !pricingDeposit) setPricingDeposit(String(pp.deposit));
            if (pp.firstHomeBuyer && !pricingFirstHomeBuyer) setPricingFirstHomeBuyer(pp.firstHomeBuyer);
            if (pp.reasonToBuy && !pricingReasonToBuy) setPricingReasonToBuy(pp.reasonToBuy);
            if (pp.rateType && !pricingRateType) setPricingRateType(pp.rateType);
            if (pp.fixedRateTerm && !pricingFixedRateTerm) setPricingFixedRateTerm(pp.fixedRateTerm);
            if (pp.repaymentType && !pricingRepaymentType) setPricingRepaymentType(pp.repaymentType);
            if (pp.loanTermValue && !pricingLoanTermValue) setPricingLoanTermValue(String(pp.loanTermValue));
            if (pp.loanTermUnit && pricingLoanTermUnit !== pp.loanTermUnit) setPricingLoanTermUnit(pp.loanTermUnit);
          }

          if (actionHasDealLendersField) {
            if (pp.selectedLenders?.length && !pricingSelectedLenders?.length) setPricingSelectedLenders(pp.selectedLenders);
          }

          if (!selectedProductsRef.current?.length) {
            if (Array.isArray(pp.selectedDeals) && pp.selectedDeals.length) {
              setSelectedProducts(pp.selectedDeals.map((deal, idx) => createSelectedProductFromPayload(deal, idx)));
            } else if (pp.selectedDeal) {
              setSelectedProducts([createSelectedProductFromPayload(pp.selectedDeal, 0)]);
            }
          }
        }

        // Mark initial data as fully loaded after all state has been set
        // Use setTimeout to ensure all state updates and re-renders have completed
        setTimeout(() => {
          if (caseId && !isInitialDataLoaded) {
            setIsInitialDataLoaded(true);
          }
        }, 200);
      }
    }, [currentActionState]); //eslint-disable-line

    useEffect(() => {
      currentActionStateRef.current = currentActionState;
      if (!!currentActionState) {
        setActionStatus(currentActionState?.caseStatus);
        if (currentActionState?.remindTime) setRemindTime(new Date(currentActionState.remindTime));
        else setRemindTime(new Date());
      }
    }, [currentActionState]); //eslint-disable-line

    useEffect(() => {
      propertyAddressRef.current = propertyAddress;
    }, [propertyAddress]);

    useEffect(() => {
      pricingLoanPurposeRef.current = pricingLoanPurpose;
    }, [pricingLoanPurpose]);

    useEffect(() => {
      pricingEstimatedPriceRef.current = pricingEstimatedPrice;
    }, [pricingEstimatedPrice]);

    useEffect(() => {
      pricingLoanAmountRef.current = pricingLoanAmount;
    }, [pricingLoanAmount]);

    useEffect(() => {
      pricingDepositRef.current = pricingDeposit;
    }, [pricingDeposit]);

    useEffect(() => {
      pricingFirstHomeBuyerRef.current = pricingFirstHomeBuyer;
    }, [pricingFirstHomeBuyer]);

    useEffect(() => {
      pricingReasonToBuyRef.current = pricingReasonToBuy;
    }, [pricingReasonToBuy]);

    useEffect(() => {
      pricingRateTypeRef.current = pricingRateType;
    }, [pricingRateType]);

    useEffect(() => {
      pricingFixedRateTermRef.current = pricingFixedRateTerm;
    }, [pricingFixedRateTerm]);

    useEffect(() => {
      pricingRepaymentTypeRef.current = pricingRepaymentType;
    }, [pricingRepaymentType]);

    useEffect(() => {
      pricingLoanTermValueRef.current = pricingLoanTermValue;
    }, [pricingLoanTermValue]);

    useEffect(() => {
      pricingLoanTermUnitRef.current = pricingLoanTermUnit;
    }, [pricingLoanTermUnit]);

    useEffect(() => {
      pricingSelectedLendersRef.current = pricingSelectedLenders;
    }, [pricingSelectedLenders]);

    useEffect(() => {
      selectedProductsRef.current = selectedProducts;
    }, [selectedProducts]);

    const sanitizePreparePricing = (pricingObj = {}) => {
      const cleaned = { ...pricingObj };
      const numericFields = ['estimatedPrice', 'loanAmount', 'deposit', 'loanTermValue'];
      numericFields.forEach((field) => {
        const raw = cleaned[field];
        if (raw === '' || raw === null || raw === undefined) {
          delete cleaned[field];
          return;
        }
        const parsed = Number(String(raw).replace(/,/g, ''));
        if (Number.isFinite(parsed)) {
          cleaned[field] = parsed;
        } else {
          delete cleaned[field];
        }
      });

      Object.keys(cleaned).forEach((key) => {
        if (cleaned[key] === '' || cleaned[key] === null || cleaned[key] === undefined) {
          delete cleaned[key];
        }
      });

      return cleaned;
    };

    const normalizeProductField = (value) => {
      if (value === null || value === undefined) return '';
      return `${value}`.trim();
    };

    const formatCurrency = (value) => {
      if (!value) return '-';
      const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]+/g, '')) : value;
      if (isNaN(numValue)) return '-';
      
      const hasFractionDigits = numValue % 1 !== 0;
      
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: hasFractionDigits ? 2 : 0,
        maximumFractionDigits: hasFractionDigits ? 2 : 0
      }).format(numValue);
    };

    const getProductFieldError = (product, fieldName) => {
      if (isActionCompleted) return '';
      // Show errors in create mode or when completion validation explicitly enabled
      const shouldShowCreateErrors = isCreateMode && hasFinancialAssessmentFields;
      const shouldShowCompletionErrors = showProductCompletionErrors;

      if (!shouldShowCreateErrors && !shouldShowCompletionErrors) return '';

      switch (fieldName) {
        case 'productName':
          return normalizeProductField(product?.productName) ? '' : 'Product name is required';
        case 'preferredDiscountedRate':
          return normalizeProductField(product?.preferredDiscountedRate) ? '' : 'Preferred discounted rate is required';
        case 'finalDiscountedRate':
          if (!shouldShowCompletionErrors) return '';
          return normalizeProductField(product?.finalDiscountedRate) ? '' : 'Final discounted rate is required';
        case 'lenderApprovalDocument':
          if (!shouldShowCompletionErrors) return '';
          return hasProductAttachment(product?.lenderApprovalDocument) ? '' : 'Lender approval file is required';
        default:
          return '';
      }
    };

    const hasProductAttachment = (doc) => {
      return !!(doc?.files?.length || doc?.originalFiles?.length);
    };

    const getProductCompletionErrors = () => {
      const needsFinancialProducts = actionHasFinancialAssessmentFields;
      if (!needsFinancialProducts) return [];

      const errors = [];

      (selectedProducts || []).forEach((product, idx) => {
        const label = `Product ${idx + 1}`;
        if (!normalizeProductField(product?.productName)) errors.push(`${label}: Product name is required`);
        if (!normalizeProductField(product?.preferredDiscountedRate)) errors.push(`${label}: Discounted rate is required`);
        if (!normalizeProductField(product?.finalDiscountedRate)) errors.push(`${label}: Final discounted rate is required`);
        if (!hasProductAttachment(product?.lenderApprovalDocument)) errors.push(`${label}: Lender approval file is required`);
      });

      return errors;
    };

    const getProductValidationMessage = () => {
      if (!(isCreateMode && hasFinancialAssessmentFields)) return '';

      return '';
    };

    const getPrepPricingInvalidReasons = () => {
      const hasFinancialFields = actionHasFinancialFields;
      const reasons = [];
      const shouldRequireSelectedLenders = (
        (actionType?.hasDealLendersField || currentActionState?.typeObj?.hasDealLendersField) && !isPrepareRatesType
      ) && !(
        isCreateMode && (
          isPreparePricingActionSelected || currentActionState?.typeObj?.uid === PREPARE_PRICING_UID
        )
      );

      if (actionHasPropertyAddressField && !propertyAddress) {
        reasons.push('Property address is required');
      }

      if (hasFinancialFields) {
        if (!pricingLoanPurpose) reasons.push('Loan purpose is required');
        if (!pricingEstimatedPrice) reasons.push('Estimated property price is required');
        if (pricingLoanPurpose === 'Refinance' && !pricingLoanAmount) reasons.push('Loan amount is required');
        if (pricingLoanPurpose === 'Purchase' && !pricingDeposit) reasons.push('Deposit amount is required');
        if (!pricingReasonToBuy) reasons.push('Reason to buy is required');
        if (pricingReasonToBuy === 'Owner Occupied' && !pricingFirstHomeBuyer) reasons.push('First home buyer selection is required');
        if (!pricingRateType) reasons.push('Rate type is required');
        if (pricingRateType === 'Fixed' && !pricingFixedRateTerm) reasons.push('Fixed rate term is required');
        if (!pricingRepaymentType) reasons.push('Repayment type is required');
        if (!pricingLoanTermValue) reasons.push('Loan term value is required');
      }

      if (shouldRequireSelectedLenders && !pricingSelectedLenders?.length) {
        reasons.push('At least one preferred lender is required');
      }

      return reasons;
    };

    useEffect(() => {
      const docsToLoad = (selectedProducts || [])
        .map((product) => {
          const doc = product.lenderApprovalDocument;
          const docId = getDocumentIdFromValue(doc);
          const hasFiles = doc?.files?.length || doc?.originalFiles?.length;
          return (!hasFiles && docId && !loadedProductDocumentIds.includes(docId)) ? docId : null;
        })
        .filter(Boolean);

      const uniqueDocIds = [...new Set(docsToLoad)];

      if (uniqueDocIds.length) {
        dispatch(getDocumentsByIds({
          documentIds: uniqueDocIds,
          onSuccess: (docs) => {
            setLoadedProductDocumentIds((prev) => [...new Set([...(prev ?? []), ...uniqueDocIds])]);
            if (docs?.length) {
              setSelectedProducts((prev) => prev.map((product) => {
                const docId = getDocumentIdFromValue(product.lenderApprovalDocument);
                const found = docs.find((d) => getDocumentIdFromValue(d) === docId);
                return found ? { ...product, lenderApprovalDocument: normalizeProductDocument(found) } : product;
              }));
            }
          },
          onError: () => {
            setLoadedProductDocumentIds((prev) => [...new Set([...(prev ?? []), ...uniqueDocIds])]);
          }
        }));
      }
    }, [selectedProducts, loadedProductDocumentIds, dispatch]);

    useEffect(() => {
      if (!productAttachModalOpen) {
        setProductAttachDocument(undefined);
        setProductAttachPurpose('create');
        setActiveProductId(null);
        setProductAttachDocumentTypes([]);
      }
    }, [productAttachModalOpen]);

    useEffect(() => {
      if (
        !!actionType?.uid
        && !!journey?.id
        && !!journey?.team
        && !!assigneeOptions?.length
        && ACTION_TYPES_WITH_DEFAULT_SETTLEMENTS_COORDINATOR_ASSIGNEE.includes(actionType.uid)
        && !caseId
      ) {
        const journeySettlementsCoordinatorId = journey.team.find((it) => it.role === USER_ROLE.SettlementsCoordinator)?.user?.id
          ?? journey.team.find((it) => it.role === USER_ROLE.SettlementsCoordinator)?.user;
        const settlementsCoordinator = assigneeOptions.find((ao) => ao.id === journeySettlementsCoordinatorId);

        if (settlementsCoordinator) setAssignedTo(settlementsCoordinator);
      }
    }, [actionType, journey, assigneeOptions]); //eslint-disable-line

    useEffect(() => {
      const productValidationMessage = getProductValidationMessage();
      const prepPricingInvalidReasons = getPrepPricingInvalidReasons();
      const isPrepPricingValid = !prepPricingInvalidReasons.length;

      const disabledReasons = [];
      if (isPropertyValuationType && actionStatus === 'COMPLETED') {
         if (!hasProductAttachment(valuationDocument)) {
             disabledReasons.push('Valuation file is required for completion');
         }
      }
      if (!actionType && !currentActionState) disabledReasons.push('Action type is not selected');
      if (!actionStatus) disabledReasons.push('Action status is missing');
      if (
        actionStatus === 'ON HOLD'
        && (!reason && (currentActionState?.caseStatus !== 'ON HOLD' || (!remindTime || (!!currentActionState?.remindTime && Math.abs((new Date(currentActionState.remindTime)).getTime() - remindTime.getTime()) > 60000))))
      ) {
        disabledReasons.push('On hold reason or remind time is missing/invalid');
      }
      if (actionStatus === 'COMPLETED' && (!assignedTo || !!checklist.find((it) => !it.isDone))) disabledReasons.push('Completed status requires assignee and all checklist items done');
      if (!journeyOwner && !actionType?.custom && (!!actionType?.customerRequired || isPrepareRatesType)) disabledReasons.push('Customer is required');
      if (!journey && !actionType?.custom && !!actionType?.customerRequired) disabledReasons.push('Journey is required');
      if (shouldShowLenderField && !selectedLender) disabledReasons.push('Lender is required');
      if (!isPrepPricingValid) disabledReasons.push(...prepPricingInvalidReasons.map((reason) => `Prepare pricing: ${reason}`));
      if ((notesHtml ?? '').length > MAX_NOTES_SIZE) disabledReasons.push('Notes exceed maximum size');
      if (isPreparePricingCreationRestricted) disabledReasons.push('Insufficient permissions to create this action');
      if (productValidationMessage) disabledReasons.push(productValidationMessage);
      if (isCreateMode && hasFinancialAssessmentFields) {
        if (!selectedProducts?.length) {
          disabledReasons.push('At least one product is required');
        } else {
          const hasProductFieldErrors = selectedProducts.some((product) =>
            !normalizeProductField(product?.productName) ||
            !normalizeProductField(product?.preferredDiscountedRate)
          );
          if (hasProductFieldErrors) {
            disabledReasons.push('Product fields are incomplete');
          }
        }
      }

      setNextDisabled(disabledReasons.length > 0);

      if (isCreateMode && isPreparePricingActionSelected) {
        const joinedReasons = disabledReasons.join('; ');
        if (joinedReasons !== lastPrepPricingLogRef.current) {
          lastPrepPricingLogRef.current = joinedReasons;
        }
      }
    }, [actionType, actionStatus, currentActionState, reason, remindTime, journeyOwner, journey, assignedTo, checklist, propertyAddress, selectedLender, propertyAddress, pricingLoanPurpose, pricingEstimatedPrice, pricingLoanAmount, pricingDeposit, pricingFirstHomeBuyer, pricingReasonToBuy, pricingRateType, pricingFixedRateTerm, pricingRepaymentType, pricingLoanTermValue, pricingSelectedLenders, isPreparePricingCreationRestricted, selectedProducts, valuationDocument, isPropertyValuationType]); //eslint-disable-line

    useEffect(() => {
      let aggregated = [];
      timeLogs.forEach((log) => {
        const idx = aggregated.findIndex((a) => a.user === log?.user);
        if (idx < 0) {
          let newItem = deepClone(log);
          const userObj = assigneeOptions.find((ao) => ao.id === log?.user);
          newItem.userName = !!userObj ? `${userObj.name} ${userObj.surname}` : 'undefined';
          newItem.lastTimerDate = log?.createdAt;
          newItem.lastEntry = log?.minutes;
          newItem.totalTime = log?.minutes;
          newItem.lastEntryId = log?.id;
          const { createdAt, updatedAt, minutes, id, ...cleanedNewItem } = newItem;
          aggregated.push(cleanedNewItem);
        } else {
          let currentItem = deepClone(aggregated[idx]);
          const isNewer = (`${log?.createdAt}`).localeCompare(currentItem.lastTimerDate) > 0;
          currentItem.lastTimerDate = isNewer ? log?.createdAt : currentItem.lastTimerDate;
          currentItem.lastEntry = isNewer ? log?.minutes : currentItem.lastEntry;
          currentItem.totalTime = currentItem.totalTime + log?.minutes;
          currentItem.lastEntryId = isNewer ? log?.id : currentItem.lastEntryId;
          aggregated[idx] = currentItem;
        }
        const sortedAggregated = (aggregated ?? [])?.sort((a, b) => (`${b.lastTimerDate}`).localeCompare(a.lastTimerDate));
        setAggregatedTimeLogs(sortedAggregated);
      });
    }, [timeLogs]); //eslint-disable-line

    useEffect(() => {
      if (!!configParameters?.businessHours?.start && configParameters?.businessHours?.finish) {
        const bhStr = `(Calculated between ${convertTimeToLocalHours(configParameters.businessHours.start)} – ${convertTimeToLocalHours(configParameters.businessHours.finish)} Sydney time, excluding weekends.)`
        setSLABreachedTooltip(<>SLA of <b>{+((currentActionState?.typeObj?.minutesToAlarm ?? 0) / 60).toFixed(2)} business hours</b> breached.<br /><i>{bhStr}</i></>);
        if (!!configParameters?.actions?.minutesInQueueToAlarm) {
          setQueueSLABreachedTooltip(<>Queue SLA of <b>{+(configParameters.actions.minutesInQueueToAlarm / 60).toFixed(2)} business hours</b> breached.<br /><i>{bhStr}</i></>);
        }
      }
    }, [configParameters, currentActionState]); //eslint-disable-line


    const checkCurrentEditors = () => {
      if (caseId) {
        dispatch(getAndUpdateEditors({
          id: caseId,
          onSuccess: (data) => {
            setCurrentEditors(data);
          },
          onError: () => {
            setCurrentEditors([]);
          }
        }));
      }
    };

    const updateActionState = (data, updatedByOther = false) => {
      if (!data) {
        displayErrorMessage(null, 'This action has been deleted by other user');
        setTimeout(() => {
          returnBack();
        }, 3000);
      } else if (currentActionStateRef.current?.updatedAt !== data.updatedAt) {
        const enrichedTypeObj = getEnrichedTypeObj(data?.typeObj);
        const normalizedData = enrichedTypeObj ? { ...data, typeObj: enrichedTypeObj } : data;
        // Mark that we're loading initial data - this blocks auto-saves
        setIsInitialDataLoaded(false);

        setNewHistory([]);
        setAssignedTo((assigneeOptionsRef.current ?? []).find((option) => option.id === normalizedData.assignee?.id) ?? null);
        setActionStatus(normalizedData.caseStatus);
        setOldHistory(normalizedData.history ?? []);
        setUrgent(normalizedData.urgent);
        if (normalizedData.typeObj?.custom) setDescription(normalizedData?.description ?? '');
        if (normalizedData.notes && currentActionState?.notes !== normalizedData.notes) {
          setNotesHtml(normalizedData.notes);
          setShouldUpdateTinyEditor(true);
        } else {
          setShouldUpdateTinyEditor(false);
        }
        setCurrentActionState(normalizedData);

        if (data.valuationDocument && (!valuationDocument || getDocumentIdFromValue(valuationDocument) !== getDocumentIdFromValue(data.valuationDocument))) {
           const valDoc = normalizeProductDocument(data.valuationDocument);
           setValuationDocument(valDoc);
           if (valDoc?.id && !valDoc.files) {
             dispatch(getDocumentsByIds({
               documentIds: [valDoc.id],
               onSuccess: (docs) => {
                 if (docs?.[0]) {
                   setValuationDocument(normalizeProductDocument(docs[0]));
                 }
               }
             }));
           }
        }

        if (!normalizedData.checklist?.length) {
          setChecklist([]);
        } else {
          const formattedChecklist = normalizedData.checklist.map((item) => {
            const itemTypeObject = normalizedData.typeObj?.checklist.find((it) => it.uid === item.uid);
            return { ...item, title: itemTypeObject?.title };
          });

          setChecklist(formattedChecklist);
        }

        setIsLogsLoading(true);
        dispatch(getCaseTimeLogs({
          caseId,
          onSuccess: (timeLogsData) => {
            setTimeLogs(timeLogsData);
            setIsLogsLoading(false);

            if (!!data.journey) {
              dispatch(getDocuments({
                journeyId: data.journey.id,
                statuses: ['Reviewed'],
                onSuccess: (documentsData) => {
                  setReviewedJourneyDocuments(documentsData?.elements ?? []);
                  //if (!!updatedByOther) displayNotification.success(`The action has been updated${updatedByOther ? ' by other user' : ''}`);
                  setInProgress(false);
                },
                onError: (data) => {
                  displayErrorMessage(data, 'Unable to retrieve journey\'s documents');
                }
              }));
            } else {
              const ids = (data.history ?? []).map((it) => it?.meta?.document).filter(Boolean);

              if (!!ids.length) {
                dispatch(getDocumentsByIds({
                  documentIds: ids,
                  onSuccess: (documentsData) => {
                    setReviewedJourneyDocuments(documentsData ?? []);
                    //if (!!updatedByOther) displayNotification.success(`The action has been updated${updatedByOther ? ' by other user' : ''}`);
                    setInProgress(false);
                  },
                  onError: (data) => {
                    displayErrorMessage(data, 'Unable to retrieve documents');
                  }
                }));
              } else {
                setInProgress(false);
              }

            }
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve action\'s time logs');
            setIsLogsLoading(false);
          }
        }));
      }
    };

    const checkAndUpdateAction = () => {
      dispatch(getCase({
        id: caseId,
        notExtended: true,
        onSuccess: (data) => {
          if (!data) {
            displayErrorMessage(null, 'This action has been deleted by other user');
            setTimeout(() => {
              returnBack();
            }, 3000);
          } else if (currentActionStateRef.current?.updatedAt !== data.updatedAt) {
            dispatch(getCase({
              id: caseId,
              onSuccess: (actionData) => {
                updateActionState(actionData, true);
              },
              onError: (data) => {
                displayErrorMessage(data, 'Unable to retrieve action');
              }
            }));
          }
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to check action state');
        }
      }));
    };

    const getElapsedTimeString = (prevDate) => {
      if (!prevDate) return '';

      let timeDiffMinutes = getElapsedTimeMinutes(prevDate, configParameters?.businessHours);
      const minutes = timeDiffMinutes % 60;
      const hours = Math.floor(timeDiffMinutes / 60);

      return hours >= 100 ? `${hours}h` : `${hours}h ${minutes}m`;
    };

    const isTimeOutAlarm = (prevDate, timeLimitMinutes) => {
      if (!prevDate || !timeLimitMinutes) return false;

      let timeDiffMinutes = getElapsedTimeMinutes(prevDate, configParameters?.businessHours);

      return timeDiffMinutes > timeLimitMinutes;
    };

    const isInQueueAlarm = (prevDate) => {
      if (!prevDate || !configParameters?.actions?.minutesInQueueToAlarm || !!assignedTo) return false;

      let timeDiffMinutes = getElapsedTimeMinutes(prevDate, configParameters?.businessHours);

      return timeDiffMinutes > configParameters?.actions?.minutesInQueueToAlarm;
    };

    const doDeleteComment = (idx) => {
      setDeleteConfirmationParameters({
        entityType: 'comment',
        entityName: null,
        action: () => {
          let updatedNewHistory = [...newHistory];
          updatedNewHistory.splice(idx, 1);
          setNewHistory(updatedNewHistory);
        }
      });
      setDeleteConfirmationOpen(true);
    };

    const doDeleteDocument = (idx) => {
      setDeleteConfirmationParameters({
        entityType: 'comment',
        entityName: null,
        action: () => {
          let updatedNewHistory = [...newHistory];
          const itemsToDelete = updatedNewHistory.splice(idx, 1);
          const docsToDelete = deepClone(itemsToDelete.map((it) => it.meta?.document?.id).filter(Boolean));
          dispatch(deleteDocuments({
            documentIds: docsToDelete,
            onSuccess: () => {
              setNewHistory(updatedNewHistory);
            },
            onError: (data) => {
              displayErrorMessage(data, 'Unable to delete document');
            }
          }));
        }
      });
      setDeleteConfirmationOpen(true);
    };

    const saveAction = () => {
      const productValidationMessage = getProductValidationMessage();
      if (productValidationMessage) {
        displayErrorMessage(null, productValidationMessage);
        return;
      }
      if (isPreparePricingCreationRestricted) {
        displayErrorMessage(null, ACTION_PERMISSION_ERROR);
        return;
      }
      setInProgress(true);
      setTimeout(() => { doSave(); }, 800);
    };

    const doSave = (updatedNewHistory, updatedAssignee, updatedActionStatus, updatedRemindTime, updatedChecklist, updatedUrgent, updatedPropertyAddress, updatedLender, updatedPreparePricing, updatedValuationDocument) => {
      if (isPreparePricingCreationRestricted && !caseId) {
        setInProgress(false);
        displayErrorMessage(null, ACTION_PERMISSION_ERROR);
        return;
      }
      const productValidationMessage = getProductValidationMessage();
      if (productValidationMessage && isCreateMode) {
        setInProgress(false);
        displayErrorMessage(null, productValidationMessage);
        return;
      }
      setInProgress(true);
      let body = (!!caseId) ? {} : {
        typeObj: actionType,
        journey: journey?._id ?? journey?.id,
        creator: effectiveUser?.id ?? effectiveUser?._id,
        customer: journeyOwner?.id ?? journeyOwner?._id
      };
      const assigneeToSet = updatedAssignee ? (updatedAssignee === 'null' ? null : updatedAssignee) : assignedTo;
      body.assignee = assigneeToSet?.id ?? assigneeToSet?._id;
      body.caseStatus = updatedActionStatus ?? actionStatus;
      body.remindTime = (actionStatus === 'ON HOLD' && !!(updatedRemindTime ?? remindTime)) ? (updatedRemindTime ?? remindTime).toISOString() : undefined;
      body.reason = actionStatus === 'ON HOLD' ? reason : undefined;
      body.notes = notesHtml ?? '';
      if (actionType?.custom || currentActionState?.typeObj?.custom) body.description = description ?? '';

      if (!!(updatedChecklist ?? checklist)?.length) {
        body.checklist = (updatedChecklist ?? checklist).map((it) => { return { uid: it.uid, isDone: !!it.isDone }; })
      } else {
        body.checklist = [];
      }

      if (updatedValuationDocument !== undefined) {
          body.valuationDocument = getDocumentIdFromValue(updatedValuationDocument);
      } else if (valuationDocument) {
          body.valuationDocument = getDocumentIdFromValue(valuationDocument);
      }

      body.history = (updatedNewHistory ?? newHistory ?? []).map((it) => {
        return {
          ...it,
          meta: {
            comment: it.meta?.comment,
            document: it.meta?.document?.id
          }
        };
      });

      body.urgent = (typeof updatedUrgent === 'boolean') ? updatedUrgent : urgent;

      // Save property address to root level if it's standalone (property valuation use case)
      if (actionHasPropertyAddressField && !actionHasDealFinderFields) {
        // FIX: Use ref for property address fallback to ensure latest value
        const addressToSave = updatedPropertyAddress !== undefined ? updatedPropertyAddress : propertyAddressRef.current;
        if (addressToSave) body.propertyAddress = addressToSave;
      }

      if (actionHasLenderField) {
        const lenderToSave = updatedLender !== undefined ? updatedLender : selectedLender;
        if (lenderToSave) body.lender = lenderToSave?.id ?? lenderToSave?._id;
      }

      // Save property address to preparePricing if deal finder fields are present
      if (actionHasPropertyAddressField || actionHasFinancialFields || actionHasDealLendersField) {

        if (actionHasDealFinderFields) {
          const pricingToSave = updatedPreparePricing ?? {};

          if (actionHasPropertyAddressField) {
            // FIX: Use ref for property address fallback
            const addressToSave = updatedPropertyAddress !== undefined ? updatedPropertyAddress : propertyAddressRef.current;
            if (addressToSave) {
              pricingToSave.propertyAddress = addressToSave;
            }
          }

          if (actionHasFinancialFields) {
            // FIX: Use Refs (.current) instead of state variables to avoid stale closures in setTimeout
            pricingToSave.loanPurpose = pricingLoanPurposeRef.current;
            pricingToSave.estimatedPrice = pricingEstimatedPriceRef.current;
            pricingToSave.loanAmount = pricingLoanAmountRef.current;
            pricingToSave.deposit = pricingDepositRef.current;
            pricingToSave.firstHomeBuyer = pricingFirstHomeBuyerRef.current;
            pricingToSave.reasonToBuy = pricingReasonToBuyRef.current;
            pricingToSave.rateType = pricingRateTypeRef.current;
            pricingToSave.fixedRateTerm = pricingFixedRateTermRef.current;
            pricingToSave.repaymentType = pricingRepaymentTypeRef.current;
            pricingToSave.loanTermValue = pricingLoanTermValueRef.current;
            pricingToSave.loanTermUnit = pricingLoanTermUnitRef.current;
          }

          // FIX: Use selectedProductsRef.current
          pricingToSave.selectedDeals = buildSelectedDealsFromProducts(selectedProductsRef.current);

          if (actionHasDealLendersField) {
            // Only use state value if not already provided in updatedPreparePricing
            if (!updatedPreparePricing || !updatedPreparePricing.hasOwnProperty('selectedLenders')) {
              // FIX: Use pricingSelectedLendersRef.current
              pricingToSave.selectedLenders = (pricingSelectedLendersRef.current || []).filter(l => l !== null && l !== undefined);
            }
          }

          body.preparePricing = sanitizePreparePricing(pricingToSave);
        }
      }

      if (!caseId) {
        dispatch(createCase({
          body,
          onSuccess: () => {
            setInProgress(false);
            returnBack();
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to create the action');
          }
        }));
      } else {
        dispatch(updateCase({
          body,
          id: caseId,
          onSuccess: (data) => {
            // Only update full action state if we're saving more than just preparePricing
            // This prevents resetting assignedTo and urgent when auto-saving pricing data
        if (updatedNewHistory !== null || updatedAssignee !== null || updatedActionStatus !== null ||
            updatedRemindTime !== null || updatedChecklist !== null || updatedUrgent !== null ||
            updatedPropertyAddress !== undefined || updatedLender !== undefined || updatedValuationDocument !== undefined) {
            updateActionState(data);
        } else {
          setCurrentActionState((prev) => {
            if (!data) return prev;
            return {
              ...(prev ?? {}),
              ...data,
              preparePricing: data.preparePricing ?? prev?.preparePricing
            };
          });
          setInProgress(false);
          setIsLoadingPreparePricingData(false);
        }
      },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to update the action');
            setIsLoadingPreparePricingData(false);
          }
        }));
      }
    };

    const getValuationDocumentTypesList = (currentDoc) => {
        const availableTypes = documentTypes ?? [];
        let filtered = availableTypes.filter((dt) => {
            const category = dt.category?.toLowerCase?.() ?? '';
            const typeName = dt.type?.toLowerCase?.() ?? '';
            // Match "Asset / Valuation report"
            return category.includes('asset') && typeName.includes('valuation');
        });

        if (currentDoc?.documentType && !filtered.find((dt) => dt.id === currentDoc.documentType?.id || dt._id === currentDoc.documentType?._id)) {
            filtered = [...filtered, currentDoc.documentType];
        }
        
        // Remove duplicates
        return filtered.map((dt) => dt?.id ? dt : ({ ...dt, id: dt?._id }))
            .filter((dt, idx, self) => {
                const typeId = dt?.id ?? dt?._id;
                return typeId && self.findIndex((item) => (item?.id ?? item?._id) === typeId) === idx;
            });
    };

    const openValuationDocumentModal = () => {
        const normalizedDoc = normalizeProductDocument(valuationDocument);
        const hasFiles = !!(normalizedDoc?.files?.length || normalizedDoc?.originalFiles?.length);

        const openWithDoc = (docToUse) => {
            const types = getValuationDocumentTypesList(docToUse);
            if (!types.length) {
                 // If no specific type found, fall back to generic or show error? 
                 // For now, let's assume types exist or let user pick from filtered list
            }
            setValuationDocumentTypes(types);
            setValuationDocument(docToUse);
            // If action is completed, view only. If exists but not completed, view/edit.
            setProductAttachPurpose(isActionCompleted ? 'view' : (hasFiles && !!caseId ? 'view' : 'create'));
            setValuationAttachModalOpen(true);
        };

        if (normalizedDoc?.id && !normalizedDoc.files) {
            dispatch(getDocumentsByIds({
                documentIds: [normalizedDoc.id],
                onSuccess: (docs) => {
                    const docFromApi = normalizeProductDocument(docs?.[0] ?? normalizedDoc);
                    setValuationDocument(docFromApi);
                    openWithDoc(docFromApi);
                },
                onError: () => openWithDoc(normalizedDoc)
            }));
        } else {
            openWithDoc(normalizedDoc);
        }
    };

    const handleValuationDocumentUpload = (document, files, originalFiles, type, isNew = false, body) => {
        setIsUploading(true);
        setCurrentProgress(0);

        const targetUserId = caseId ? undefined : (journeyOwner?.id ?? journeyOwner?._id ?? user?.id ?? user?._id);

        const finalCallback = (docObj) => {
             setValuationDocument(docObj);
             setValuationAttachModalOpen(false);
             setIsUploading(false);
             setCurrentProgress(0);
             // Auto-save the action with the new document
             doSave(null, null, null, null, null, null, undefined, undefined, undefined, docObj);
        };

        const uploadFiles = (newDocument) => {
            const targetId = getDocumentIdFromValue(newDocument ?? document);
            if (!targetId) {
                setIsUploading(false);
                return;
            }

            const filesCallback = () => {
                // Refresh doc details
                 dispatch(getDocumentsByIds({
                    documentIds: [targetId],
                    onSuccess: (docs) => {
                        finalCallback(normalizeProductDocument(docs?.[0] ?? newDocument));
                    },
                    onError: () => finalCallback(normalizeProductDocument(newDocument))
                 }));
            };

            if (files?.length) {
                dispatch(uploadDocumentFiles({
                    documentId: targetId,
                    files,
                    onSuccess: () => {
                         if (originalFiles?.length) {
                             dispatch(uploadDocumentOriginalFiles({
                                documentId: targetId,
                                files: originalFiles,
                                onSuccess: filesCallback,
                                onError: (d) => { displayErrorMessage(d, 'Unable to upload original files'); setIsUploading(false); },
                                onProgressEvent: (p) => setCurrentProgress(p ?? 0)
                             }));
                         } else {
                             filesCallback();
                         }
                    },
                    onError: (d) => { displayErrorMessage(d, 'Unable to upload files'); setIsUploading(false); },
                    onProgressEvent: (p) => setCurrentProgress(p ?? 0)
                }));
            } else if (originalFiles?.length) {
                 dispatch(uploadDocumentOriginalFiles({
                    documentId: targetId,
                    files: originalFiles,
                    onSuccess: filesCallback,
                    onError: (d) => { displayErrorMessage(d, 'Unable to upload original files'); setIsUploading(false); },
                    onProgressEvent: (p) => setCurrentProgress(p ?? 0)
                 }));
            } else {
                filesCallback();
            }
        };

        const sanitizedBody = { ...(body ?? {}) };
        const targetJourneyId = sanitizedBody?.journey?.id ?? sanitizedBody?.journey?._id ?? sanitizedBody?.journey ?? journey?.id ?? journey?._id;
        
        delete sanitizedBody.journey;
        const metadata = [...(sanitizedBody.metadata ?? [])];
        if (caseId && !metadata.find((m) => m?.name === 'caseId')) {
            metadata.push({ name: 'caseId', value: caseId });
        }

        const baseBody = {
            ...sanitizedBody,
            documentType: type.id,
            internal: true,
            user: sanitizedBody.user ?? targetUserId,
            requiredUser: sanitizedBody.requiredUser ?? targetUserId,
            metadata,
            journey: targetJourneyId,
            case: caseId ? caseId : undefined
        };

        if (isNew) {
            dispatch(createDocument({
                body: baseBody,
                onSuccess: (data) => uploadFiles(data),
                onError: (d) => { displayErrorMessage(d, 'Unable to create document'); setIsUploading(false); }
            }));
        } else if (!document?.journey && baseBody.journey) {
            const documentId = getDocumentIdFromValue(document);
            dispatch(updateDocument({
                documentId,
                body: {
                    journey: baseBody.journey,
                    metadata: baseBody.metadata,
                    user: baseBody.user,
                    requiredUser: baseBody.requiredUser,
                    internal: baseBody.internal,
                    documentType: baseBody.documentType
                },
                onSuccess: () => uploadFiles(document),
                onError: (d) => { displayErrorMessage(d, 'Unable to update document'); setIsUploading(false); }
            }));
        } else {
             // Update logic if needed, mostly for doc type or metadata
             uploadFiles(document);
        }
    };

    const checkIfDataLoaded = () => {
      return (!!actionTypeOptions?.length || !!customActionTypeOptions?.length)
        && !!assigneeOptions?.length
        && !!documentTypes?.length
        && ((!!journey && !!journeyOwner) || !journeyId)
        && (!!currentActionState || !caseId);
    };

    const setInputTouched = (id) => {
      if (id > touchedInputs) { setTouchedInputs(id); }
    };

    const setPricingTouched = (id) => {
      if (!touchedPricingInputs.includes(id)) {
        setTouchedPricingInputs([...touchedPricingInputs, id]);
      }
    };

    const ifValidationActive = (id) => {
      const pricingFieldIds = [8, 11, 12, 20, 13, 15, 14, 16, 17, 18, 21];

      if (pricingFieldIds.includes(id)) { 
        const currentIndex = pricingFieldIds.indexOf(id);
        for (let i = currentIndex; i < pricingFieldIds.length; i++) {
          if (touchedPricingInputs.includes(pricingFieldIds[i])) {
            return true;
          }
        }
        return false;
      }

      // For non-pricing fields, use original logic
      return (id <= touchedInputs);
    };

    const rateTypeHint = 'A variable-rate home loan can go up or down over time, depending on the RBA cash rate and a lender\'s decisions.' +
      ' A fixed-rate home loan keeps the same rate and repayments during the fixed term.';
    const fixedRateTermHint = 'This is the period during which a fixed interest rate applies.' +
      ' After that, the loan usually reverts to a variable rate.';

    const switchActiveHint = (hintId, event) => {
      event.stopPropagation();
      event.preventDefault();
      setActiveHint(hintId === activeHint ? undefined : hintId);
    };

    function getMaxSelectableProducts() {
      return actionType?.maxLenders ?? currentActionState?.typeObj?.maxLenders ?? 6;
    }

    const getDocumentIdFromValue = (doc) => {
      if (!doc) return undefined;
      if (typeof doc === 'string') return doc;
      if (typeof doc === 'object') {
        return doc.id ?? doc._id ?? doc.document ?? doc.documentId ?? doc?.document?._id ?? doc?.document?.id;
      }
      return undefined;
    };

    const normalizeProductDocument = (doc) => {
      const docId = getDocumentIdFromValue(doc);
      if (!doc && !docId) return undefined;
      if (doc && typeof doc === 'object' && (doc.files || doc.originalFiles || doc.documentType)) {
        return { ...doc, id: docId ?? doc.id ?? doc._id };
      }
      return docId ? { id: docId } : undefined;
    };

    const buildSelectedDealsFromProducts = (products = []) => {
      return (products || []).map((product) => ({
        internalId: product.id,
        dealId: product.dealId,
        lenderId: product.lenderId,
        lenderName: product.lenderName,
        name: product.productName,
        rate: product.rate,
        comparisonRate: product.comparisonRate,
        lmi: product.lmi,
        preferredDiscountedRate: product.preferredDiscountedRate,
        finalDiscountedRate: product.finalDiscountedRate,
        comments: product.comments,
        lenderApprovalDocument: getDocumentIdFromValue(product.lenderApprovalDocument)
      }));
    };

    const createSelectedProductFromPayload = (dealPayload, idx = 0) => {
      if (!dealPayload) return null;
      const lenderObject = typeof dealPayload.lender === 'object' ? dealPayload.lender : undefined;
      return {
        id: dealPayload.internalId ?? `${dealPayload.id ?? dealPayload.dealId ?? 'product'}-${Date.now()}-${idx}`,
        dealId: dealPayload.dealId ?? dealPayload.id,
        lenderId: lenderObject?.id ?? dealPayload.lenderId ?? lenderObject?._id,
        lenderName: lenderObject?.name ?? dealPayload.lenderName ?? (typeof dealPayload.lender === 'string' ? dealPayload.lender : ''),
        productName: dealPayload.name ?? dealPayload.productName ?? '',
        rate: dealPayload.rate ?? '',
        comparisonRate: dealPayload.comparisonRate ?? '',
        lmi: dealPayload.lmi ?? '',
        preferredDiscountedRate: dealPayload.preferredDiscountedRate ?? '',
        finalDiscountedRate: dealPayload.finalDiscountedRate ?? '',
        comments: dealPayload.comments ?? '',
        lenderApprovalDocument: normalizeProductDocument(dealPayload.lenderApprovalDocument)
      };
    };

    const mergeProductsUnique = (incoming = [], base = []) => {
      const existing = base || [];
      const combined = [...existing];
      const seen = new Set(existing.map((p) => p.id || p.internalId || p.dealId || `${p.productName}-${p.lenderId}-${p.dealId}`));
      incoming.forEach((p) => {
        const key = p.id || p.internalId || p.dealId || `${p.productName}-${p.lenderId}-${p.dealId}-${Date.now()}`;
        if (!seen.has(key)) {
          seen.add(key);
          combined.push(p);
        }
      });
      return combined;
    };

    const handleSelectedProductChange = (productId, fieldName, value) => {
      if (isActionCompleted) return;
      setSelectedProducts((prev) => {
        const updated = prev.map((product) => product.id === productId ? { ...product, [fieldName]: value } : product);
        updateLocalStorageProducts(updated);
        updatePreparePricingDataDebounced({}, updated);
        return updated;
      });
    };

    const handleRemoveSelectedProduct = (productId) => {
      if (isActionCompleted) return;
      setSelectedProducts((prev) => {
        const filtered = prev.filter((product) => product.id !== productId);
        updateLocalStorageProducts(filtered);
        updatePreparePricingDataDebounced({}, filtered);
        return filtered;
      });
    };
    const updateProductDocumentState = (productId, document) => {
      if (!productId) return;
      handleSelectedProductChange(productId, 'lenderApprovalDocument', normalizeProductDocument(document));
    };

    const navigateToProductDetails = (product) => {
      const dealId = product?.dealId || product?.id;
      if (!dealId) {
        displayErrorMessage(null, 'Unable to open product details (missing deal id)');
        return;
      }

      const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;

      const query = queryString.stringify({
        deal: dealId,
        source: (source === 'prepare_rates_research' || isPrepareRatesType) ? 'prepare_rates_research' : undefined,
        returnUrl,
        hideSelectProduct: true
      }, { skipNull: true, skipEmptyString: true });

      history.push(`/find-deals/deal-details-specialist${query ? `?${query}` : ''}`);
    };

    const downloadProductFile = (file, documentId) => {
      if (!file?.fileKey) {
        displayErrorMessage(null, 'Unable to download file');
        return;
      }
      dispatch(downloadFile({
        fileKey: file.fileKey,
        onSuccess: (data) => {
          if (data.fileLocation) {
            axios.get(data.fileLocation, { responseType: 'arraybuffer' })
              .then((result) => {
                let generatedFile;
                try {
                  generatedFile = new File([result.data], file.originalName, getFileTypeObject(file.originalName));
                } catch (e) {
                  generatedFile = new Blob([result.data], getFileTypeObject(file.originalName));
                }
                const url = window.URL.createObjectURL(generatedFile);
                const link = window.document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.originalName ?? 'Document');
                window.document.body.appendChild(link);
                setTimeout(() => {
                  link.click();
                  try { window.document.body.removeChild(link); } catch { }
                  setTimeout(() => {
                    try { window.URL.revokeObjectURL(url); } catch { }
                  }, 100);
                }, 10);
              })
              .catch((result) => {
                displayErrorMessage(result.data, 'Unable to download file');
              });
          }
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to download file');
        }
      }));
    };

    const previewProductFile = (file) => {
      if (!file?.fileKey) return;
      const destination = `${config.ORIGIN}/document-preview/${file.fileKey}?name=${encodeURI(file.originalName ?? 'Document')}`;
      window.open(destination);
    };

    const deleteProductFile = (file, documentId) => {
      if (!documentId || !file?.key) return;
      dispatch(removeDocumentFile({
        documentId,
        fileId: file.key,
        onSuccess: (data) => {
          setSelectedProducts((prev) => prev.map((p) => {
            if (getDocumentIdFromValue(p.lenderApprovalDocument) === documentId) {
              const updatedFiles = (p.lenderApprovalDocument?.files ?? []).filter((f) => f.key !== file.key);
              const updatedDoc = { ...p.lenderApprovalDocument, files: updatedFiles };
              if (!(updatedDoc.files?.length) && !(updatedDoc.originalFiles?.length)) {
                return { ...p, lenderApprovalDocument: undefined };
              }
              return { ...p, lenderApprovalDocument: updatedDoc };
            }
            return p;
          }));
        },
        onError: (data) => displayErrorMessage(data, 'Unable to delete file')
      }));
    };

    const deleteValuationFile = (file, documentId) => {
      if (!documentId || !file?.key) return;
      dispatch(removeDocumentFile({
        documentId,
        fileId: file.key,
        onSuccess: (data) => {
          if (valuationDocument && getDocumentIdFromValue(valuationDocument) === documentId) {
            const updatedDoc = { ...valuationDocument };
            if (updatedDoc.files) {
              updatedDoc.files = updatedDoc.files.filter(f => f.key !== file.key);
            }
            setValuationDocument(updatedDoc);
          }
        },
        onError: (data) => displayErrorMessage(data, 'Unable to delete file')
      }));
    };

    const getCompliancePricingDocumentTypes = (currentDoc) => {
      const preferredUIDs = ['pricing', 'compliance'];
      const availableTypes = documentTypes ?? [];
      let filtered = availableTypes.filter((dt) => preferredUIDs.includes(dt.uid));

      if (!filtered.length) {
        filtered = availableTypes.filter((dt) => {
          const category = dt.category?.toLowerCase?.();
          const typeName = dt.type?.toLowerCase?.();
          return category === 'pricing'
            || category === 'compliance'
            || typeName?.includes('pricing')
            || typeName?.includes('compliance');
        });
      }

      if (currentDoc?.documentType && !filtered.find((dt) => dt.id === currentDoc.documentType?.id || dt._id === currentDoc.documentType?._id)) {
        filtered = [...filtered, currentDoc.documentType];
      }

      return filtered
        .map((dt) => dt?.id ? dt : ({ ...dt, id: dt?._id }))
        .filter((dt, idx, self) => {
          const typeId = dt?.id ?? dt?._id;
          return typeId && self.findIndex((item) => (item?.id ?? item?._id) === typeId) === idx;
        });
    };

    const openProductDocumentModal = (product) => {

      const normalizedDoc = normalizeProductDocument(product.lenderApprovalDocument);
      const hasFiles = !!(normalizedDoc?.files?.length || normalizedDoc?.originalFiles?.length);

      const openWithDoc = (docToUse) => {
        const availableTypes = getCompliancePricingDocumentTypes(docToUse);
        if (!availableTypes.length) {
          displayErrorMessage(null, 'Unable to find compliance/pricing document type');
          return;
        }

        setActiveProductId(product.id);
        setProductAttachDocument(normalizeProductDocument(docToUse));
        setProductAttachDocumentTypes(availableTypes);
        setProductAttachPurpose(hasFiles && !!caseId ? 'view' : 'create');
        setProductAttachModalOpen(true);
      };

      if (normalizedDoc?.id && !normalizedDoc.files) {
        dispatch(getDocumentsByIds({
          documentIds: [normalizedDoc.id],
          onSuccess: (docs) => {
            const docFromApi = normalizeProductDocument(docs?.[0] ?? normalizedDoc);
            updateProductDocumentState(product.id, docFromApi);
            openWithDoc(docFromApi);
          },
          onError: () => openWithDoc(normalizedDoc)
        }));
      } else {
        openWithDoc(normalizedDoc);
      }
    };

    const handleProductDocumentUpload = (document, files, originalFiles, type, isNew = false, body) => {
      if (!activeProductId) {
        setProductAttachModalOpen(false);
        return;
      }

      const targetUserId = caseId ? undefined : (journeyOwner?.id ?? journeyOwner?._id ?? user?.id ?? user?._id);
      setIsUploading(true);
      setCurrentProgress(0);

      const loadAndAttachDocument = (docId, fallbackDoc) => {
        if (!docId) {
          setIsUploading(false);
          setCurrentProgress(0);
          setProductAttachModalOpen(false);
          return;
        }

        dispatch(getDocumentsByIds({
          documentIds: [docId],
          onSuccess: (docs) => {
            const retrieved = normalizeProductDocument(docs?.[0] ?? fallbackDoc ?? { id: docId });
            updateProductDocumentState(activeProductId, retrieved);
            setLoadedProductDocumentIds((prev) => [...new Set([...(prev ?? []), docId])]);

            setProductAttachModalOpen(false);
            setProductAttachPurpose('view');
            setProductAttachDocument(undefined);
            setActiveProductId(null);
            setIsUploading(false);
            setCurrentProgress(0);
          },
          onError: () => {
            const normalized = normalizeProductDocument(fallbackDoc ?? { id: docId });
            updateProductDocumentState(activeProductId, normalized);
            setLoadedProductDocumentIds((prev) => [...new Set([...(prev ?? []), docId])]);
            setProductAttachModalOpen(false);
            setProductAttachPurpose('view');
            setProductAttachDocument(undefined);
            setActiveProductId(null);
            setIsUploading(false);
            setCurrentProgress(0);
          }
        }));
      };

      const uploadFiles = (newDocument) => {
        const targetId = getDocumentIdFromValue(newDocument ?? document);
        if (!targetId) {
          setIsUploading(false);
          setCurrentProgress(0);
          displayErrorMessage(null, 'Unable to determine document id');
          return;
        }

        const refresh = (docObj) => loadAndAttachDocument(targetId, docObj ?? newDocument ?? document);

        const originalCallback = () => {
          setCurrentProgress(0);
          if (files?.length) {
            dispatch(uploadDocumentFiles({
              documentId: targetId,
              files,
              onSuccess: () => {
                refresh(newDocument ?? document);
              },
              onError: (data) => {
                setIsUploading(false);
                setCurrentProgress(0);
                displayErrorMessage(data, 'Unable to upload document files');
              },
              onProgressEvent: (progress) => {
                setCurrentProgress(progress ?? 0);
              }
            }));
          } else {
            refresh(newDocument ?? document);
          }
        };

        if (originalFiles?.length) {
          dispatch(uploadDocumentOriginalFiles({
            documentId: targetId,
            files: originalFiles,
            onSuccess: () => {
              originalCallback();
            },
            onError: (data) => {
              setIsUploading(false);
              setCurrentProgress(0);
              displayErrorMessage(data, 'Unable to upload original document files');
            },
            onProgressEvent: (progress) => {
              setCurrentProgress(progress ?? 0);
            }
          }));
        } else {
          originalCallback();
        }
      };

      const sanitizedBody = { ...(body ?? {}) };
      delete sanitizedBody.journey;

      const metadata = [...(sanitizedBody.metadata ?? [])];
      if (caseId && !metadata.find((m) => m?.name === 'caseId')) {
        metadata.push({ name: 'caseId', value: caseId });
      }

      const baseBody = {
        ...sanitizedBody,
        documentType: type.id,
        internal: true,
        user: sanitizedBody.user ?? targetUserId,
        requiredUser: sanitizedBody.requiredUser ?? targetUserId,
        metadata,
        journey: caseId ? undefined : (journey?.id ? journey.id : undefined),
        case: caseId ? caseId : undefined
      };

      if (isNew) {
        dispatch(createDocument({
          body: baseBody,
          onSuccess: (data) => {
            uploadFiles(data);
          },
          onError: (data) => {
            setIsUploading(false);
            setCurrentProgress(0);
            displayErrorMessage(data, 'Unable to create document');
          }
        }));
      } else if (document?.documentType?.id === type.id && !(Object.keys(body ?? {})).length) {
        uploadFiles(document);
      } else {
        dispatch(updateDocument({
          documentId: getDocumentIdFromValue(document),
          body: baseBody,
          onSuccess: () => {
            uploadFiles(document);
          },
          onError: (data) => {
            setIsUploading(false);
            setCurrentProgress(0);
            displayErrorMessage(data, 'Unable to update document');
          }
        }));
      }
    };

    const buildPrepareRatesPayload = () => {
      // Ensure returnUrl carries the prepare_rates_research marker so restore logic triggers on return
      const currentQuery = queryString.parse(window.location.search);
      const normalizedReturnUrlQuery = queryString.stringify({
        ...currentQuery,
        source: 'prepare_rates_research'
      }, { skipNull: true, skipEmptyString: true });
      const normalizedReturnUrl = `${window.location.pathname}${normalizedReturnUrlQuery ? `?${normalizedReturnUrlQuery}` : ''}${window.location.hash || ''}`;

      const normalizedSelectedProducts = (selectedProducts || []).map((product, idx) => ({
        internalId: product.id,
        dealId: product.dealId,
        lenderId: product.lenderId,
        lenderName: product.lenderName,
        productName: product.productName,
        rate: product.rate,
        comparisonRate: product.comparisonRate,
        lmi: product.lmi,
        preferredDiscountedRate: product.preferredDiscountedRate,
        finalDiscountedRate: product.finalDiscountedRate,
        comments: product.comments,
        lenderApprovalDocument: getDocumentIdFromValue(product.lenderApprovalDocument),
        idx
      }));

      return {
        propertyAddress,
        loanPurpose: pricingLoanPurpose,
        estimatedPrice: pricingEstimatedPrice,
        deposit: pricingDeposit,
        loanAmount: pricingLoanAmount,
        firstHomeBuyer: pricingFirstHomeBuyer,
        reasonToBuy: pricingReasonToBuy,
        rateType: pricingRateType,
        fixedRateTerm: pricingFixedRateTerm,
        repaymentType: pricingRepaymentType,
        loanTermValue: pricingLoanTermValue,
        loanTermUnit: pricingLoanTermUnit,
        // loan term is intentionally NOT sent to Deal Finder — it should be saved in the action only
        // Provide defaults for fields that exist in Deal Finder but are not part of Create action
        preferredLenderType: 'All',
        preferredBankType: 'All',
        withCashback: 'no',
        isPersonalised: 'no',
        preferredLender: undefined,
        selectedLenderId: selectedLender?.id ?? selectedLender?._id ?? null,
        journeyId: journey?.id ?? null,
        journeyName: journey?.name ?? null,
        caseId: caseId ?? null,
        returnUrl: normalizedReturnUrl,
        actionTypeUid: actionType?.uid ?? currentActionState?.typeObj?.uid ?? null,
        journeyOwnerId: journeyOwner?._id ?? journeyOwner?.id ?? null,
        journeyOwnerName: journeyOwner?.name ?? null,
        journeyOwnerSurname: journeyOwner?.surname ?? null,
        assignedToId: assignedTo?.id ?? null,
        urgent,
        selectedProducts: normalizedSelectedProducts
      };
    };

    const canLaunchDealFinder = () => {
      if (!isCreateMode && actionStatus === 'COMPLETED') return false;
      if (selectedProducts.length >= getMaxSelectableProducts()) return false;
      if (!propertyAddress) return false;
      if (!pricingEstimatedPrice || !pricingLoanPurpose || !pricingReasonToBuy || !pricingRateType || !pricingRepaymentType || !pricingLoanTermValue) return false;
      // Loan amount is required only for Refinance flows
      if (pricingLoanPurpose === 'Refinance' && !pricingLoanAmount) return false;
      // Deposit is required only for Purchase flows
      if (pricingLoanPurpose === 'Purchase' && !pricingDeposit) return false;
      // First home buyer selection is only shown for Owner Occupied reason
      if (pricingReasonToBuy === 'Owner Occupied' && !pricingFirstHomeBuyer) return false;
      if (pricingRateType === 'Fixed' && !pricingFixedRateTerm) return false;
      return true;
    };

    const handleAddProductClick = () => {
      if (!isCreateMode && actionStatus === 'COMPLETED') {
        displayErrorMessage(null, 'Cannot add products to a completed action');
        return;
      }
      if (!canLaunchDealFinder()) {
        [8, 11, 12, 13, 14, 15, 16, 17, 18, 20, 21].forEach(id => setPricingTouched(id));
        displayErrorMessage(null, 'Please complete the financial fields before searching for a product.');
        return;
      }

      if (selectedProducts.length >= getMaxSelectableProducts()) {
        displayErrorMessage(null, `A maximum of ${getMaxSelectableProducts()} products can be added.`);
        return;
      }

      const prepareRatesPayload = buildPrepareRatesPayload();
      try {
        localStorage.setItem(PREPARE_PRICING_STORAGE_KEY, JSON.stringify(prepareRatesPayload));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unable to persist prepare pricing payload', error);
      }
      const queryParams = queryString.stringify({
        source: 'prepare_rates_research',
        returnUrl: prepareRatesPayload.returnUrl,
        loanPurpose: prepareRatesPayload.loanPurpose,
        estimatedPrice: prepareRatesPayload.estimatedPrice,
        deposit: prepareRatesPayload.deposit,
        loanAmount: prepareRatesPayload.loanAmount,
        firstHomeBuyer: prepareRatesPayload.firstHomeBuyer,
        reasonToBuy: prepareRatesPayload.reasonToBuy,
        rateType: prepareRatesPayload.rateType,
        fixedRateTerm: prepareRatesPayload.fixedRateTerm,
        repaymentType: prepareRatesPayload.repaymentType,
        loanTermValue: prepareRatesPayload.loanTermValue,
        loanTermUnit: prepareRatesPayload.loanTermUnit
      }, { skipNull: true, skipEmptyString: true });

      const targetUrl = `/find-deals/find-deal-specialist${queryParams ? `?${queryParams}` : ''}`;
      history.push(targetUrl);
    };

    const updateLocalStorageProducts = (newProducts) => {
      try {
        const raw = localStorage.getItem(PREPARE_PRICING_STORAGE_KEY);
        if (raw) {
          const stored = JSON.parse(raw);
          const normalizedSelectedProducts = newProducts.map((product, idx) => ({
            internalId: product.id,
            dealId: product.dealId,
            lenderId: product.lenderId,
            lenderName: product.lenderName,
            productName: product.productName,
            rate: product.rate,
            comparisonRate: product.comparisonRate,
            lmi: product.lmi,
            preferredDiscountedRate: product.preferredDiscountedRate,
            finalDiscountedRate: product.finalDiscountedRate,
            comments: product.comments,
            lenderApprovalDocument: getDocumentIdFromValue(product.lenderApprovalDocument),
            idx
          }));

          stored.selectedProducts = normalizedSelectedProducts;
          localStorage.setItem(PREPARE_PRICING_STORAGE_KEY, JSON.stringify(stored));
        }
      } catch (e) {
        console.error('Failed to update storage with new products', e);
      }
    };

    const syncSelectedDealFromStorage = () => {
      const rawNewDeal = localStorage.getItem(PREPARE_PRICING_SELECTED_DEAL_KEY);
      if (!rawNewDeal) return;

      localStorage.removeItem(PREPARE_PRICING_SELECTED_DEAL_KEY);

      let parsedNewDeal = null;
      try {
        parsedNewDeal = JSON.parse(rawNewDeal);
      } catch (error) {
        console.error('Unable to parse selected deal payload', error);
        return;
      }

      if (parsedNewDeal?.deal) {
        const rawMainStorage = localStorage.getItem(PREPARE_PRICING_STORAGE_KEY);
        let currentStoredProducts = [];

        if (rawMainStorage) {
          try {
            const storedData = JSON.parse(rawMainStorage);
            if (Array.isArray(storedData.selectedProducts)) {
              currentStoredProducts = storedData.selectedProducts
                .map((deal, idx) => createSelectedProductFromPayload(deal, idx))
                .filter(Boolean);
            }
          } catch (e) {
            console.error('Error parsing main storage for merge', e);
          }
        }

        const mappedProduct = createSelectedProductFromPayload(parsedNewDeal.deal, currentStoredProducts.length);

        if (mappedProduct) {
          const mergedProducts = mergeProductsUnique([mappedProduct], currentStoredProducts);

          if (mergedProducts.length > getMaxSelectableProducts()) {
            displayErrorMessage(null, `A maximum of ${getMaxSelectableProducts()} products can be added.`);
            return;
          }

          updateLocalStorageProducts(mergedProducts);

          setSelectedProducts(mergedProducts);
        }
      }
    };

    const onJourneyOwnerSearchStringChanged = (newValue) => {
      let options = {
        limit: 10,
        onSuccess: (data) => {
          const newOptions = data?.elements ?? [];
          if (journeyOwner && !newOptions.find(o => o.id === journeyOwner.id || o._id === journeyOwner.id)) {
            setJourneyOwnerOptions([journeyOwner, ...newOptions]);
          } else {
            setJourneyOwnerOptions(newOptions);
          }
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve allowed users');
        }
      };
      if (newValue) options.search = newValue;

      dispatch(getAllowedUsersWithDebounce(options));
    };

    const onJourneySearchStringChanged = (newValue) => {
      setJourneySearchString(newValue);
    };

    const onAddressInputChanged = (searchString) => {
      setPropertyAddressInput(searchString);
      const options = {
        address: searchString,
        onSuccess: (data) => {
          setAddressOptions(data?.slice?.(0, 20) ?? []);
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve address suggestions');
        }
      };

      if (searchString?.length >= 3) dispatch(getAddressSuggestionsWithDebounce(options));
      else setAddressOptions([]);
    };

    const onLenderInputChanged = (searchString) => {
      setNoLenderOptionsText(searchString?.length ? 'Loading...' : 'Start typing to search');
      const options = {
        searchString,
        onSuccess: (data) => {
          if (!searchString?.length) {
            setLenderOptions([]);
            setNoLenderOptionsText('Start typing to search');
          } else {
            setLenderOptions(data?.elements?.slice?.(0, 10) || []);
            setNoLenderOptionsText('No results found');
          }
        },
        onError: (data) => {
          displayErrorMessage(data, 'Unable to retrieve lenders.');
          setLenderOptions([]);
          setNoLenderOptionsText('No results found');
        }
      };

      dispatch(getLendProvidersWithDebounce(options));
    };

    const onModeChange = () => {
      const newVal = !isCustomAddress;
      let newAddress = {};

      if (newVal) {
        newAddress.country = propertyAddress?.country ?? 'Australia';
        newAddress.fullAddress = propertyAddress?.fullAddress ?? '';
      } else {
        //switching to autocomplete mode
        newAddress = null;
        setPropertyAddressInput('');
      }

      setPropertyAddress(newAddress);
      setIsCustomAddress(newVal);
    };

    const isUserInSpecialistsList = () => {
      return !!assigneeOptions.find((option) => option.id === effectiveUser?.id) && assignedTo?.id !== effectiveUser?.id;
    };

    const doAssignToMe = () => {
      const newAssignee = assigneeOptions.find((option) => option.id === effectiveUser?.id);
      setAssignedTo(newAssignee);
      if (!!caseId) doSave(null, newAssignee);
    }

    const onChangeRemindTime = (date, id) => {
      setRemindTime(new Date() > date ? new Date() : date);
      setInputTouched(id);

      if (!!caseId && actionStatus === 'ON HOLD' && !!remindTime && !!reason) doSave(null, null, null, new Date() > date ? new Date() : date);
    };

    const onAddComment = () => {
      setCommentHtml('');
      setIsEditingComment(true);
    };

    const onSaveComment = () => {
      const updatedNewHistory = [...(newHistory ?? []), {
        createdBy: effectiveUser?.id,
        createdByName: `${effectiveUser?.name} ${effectiveUser?.surname}`,
        historyItemType: 'Commented',
        meta: {
          comment: commentHtml
        }
      }];

      setNewHistory(updatedNewHistory);

      if (!!caseId) doSave(updatedNewHistory);
      else setNewHistory(updatedNewHistory);
    };

    const onUrgentChange = () => {
      setUrgent(!urgent);
    };

    const onCreateTimeLog = () => {
      setCreateTimeLogParameters({
        yesAction: (time) => {
          const minutes = Number(time.minutes ?? 0) + 60 * Number(time.hours ?? 0);
          dispatch(createCaseTimeLog({
            body: {
              minutes,
              case: caseId,
              user: user?.id,
              journey: journey?.id ?? undefined,
              customer: journey?.user?.id ?? undefined,
            },
            onSuccess: (data) => {
              setTimeLogs([data, ...timeLogs]);
              setCreateTimeLogOpen(false);
            },
            onError: (data) => {
              displayErrorMessage(data, 'Unable to create the time log');
            },
          }));
        }
      });

      setCreateTimeLogOpen(true);
    };

    const onEditTimeLog = () => {
      let currentTimeLogs = deepClone(timeLogs);
      const currentIndex = currentTimeLogs.findIndex((ctl) => ctl.id === actionLogId);
      const currentLog = currentIndex >= 0 ? currentTimeLogs[currentIndex] : undefined;
      const hours = Math.floor(currentLog.minutes / 60);
      const minutes = currentLog.minutes % 60;

      setCreateTimeLogParameters({
        yesAction: (time) => {
          const minutes = Number(time.minutes ?? 0) + 60 * Number(time.hours ?? 0);
          dispatch(updateCaseTimeLog({
            minutes,
            logId: actionLogId,
            onSuccess: (data) => {
              if (currentIndex >= 0) {
                currentTimeLogs[currentIndex] = data;
              }

              setTimeLogs(currentTimeLogs);
              setCreateTimeLogOpen(false);
            },
            onError: (data) => {
              displayErrorMessage(data, 'Unable to update the time log entry');
            },
          }));
        },
        initialHours: hours > 0 ? hours.toString() : '',
        initialMinutes: minutes > 0 ? minutes.toString() : '',
      });

      setCreateTimeLogOpen(true);
    };

    const onAddDocument = () => {
      setPurpose('create');
      setLimitationMode('actionDocument');
      setDocumentToView(undefined);
      setOpenAttachFiles(true);
    };

    const onViewDocument = (doc) => {
      setPurpose('view');
      setLimitationMode('not-editable');
      setDocumentToView(doc);
      setOpenAttachFiles(true);
    };

    const addDocumentHistoryItem = (document) => {
      const updatedNewHistory = [...(newHistory ?? []), {
        createdBy: effectiveUser?.id,
        createdByName: `${effectiveUser?.name} ${effectiveUser?.surname}`,
        historyItemType: 'Attached file',
        meta: {
          document
        }
      }];

      setNewHistory(updatedNewHistory);

      if (!!caseId) doSave(updatedNewHistory);
    };

    const doUpload = (document, files, originalFiles, type, isNew = false, body, mustBeInternal = false) => {
      setIsUploading(true);
      setCurrentProgress(0);
      const uploadFiles = (newDocument) => {
        const refresh = () => {
          setOpenAttachFiles(false);
          setCurrentProgress(0);
          setIsUploading(false);
        };

        const originalCallback = () => {
          setCurrentProgress(0);
          if (files?.length) {
            dispatch(uploadDocumentFiles({
              documentId: document?.id ?? newDocument?.id,
              files,
              onSuccess: () => {
                dispatch(updateDocument({
                  documentId: newDocument?.id,
                  body: {
                    ...(body ?? {}),
                    currentStatus: 'Reviewed',
                    journey: body?.journey?.id ?? body?.journey
                  },
                  onSuccess: (data) => {
                    addDocumentHistoryItem(data);
                    refresh();
                  },
                  onError: (data2) => {
                    setIsUploading(false);
                    setCurrentProgress(0);
                    displayErrorMessage(data2, 'Unable to update document');
                  }
                }));
              },
              onError: (data) => {
                setIsUploading(false);
                setCurrentProgress(0);
                displayErrorMessage(data, 'Unable to upload document files');
              },
              onProgressEvent: (progress) => {
                setCurrentProgress(progress ?? 0);
              }
            }));
          } else {
            addDocumentHistoryItem(newDocument);
            refresh();
          }
        };

        if (originalFiles?.length) {
          dispatch(uploadDocumentOriginalFiles({
            documentId: document?.id ?? newDocument?.id,
            files: originalFiles,
            onSuccess: () => {
              originalCallback();
            },
            onError: (data) => {
              setIsUploading(false);
              setCurrentProgress(0);
              displayErrorMessage(data, 'Unable to upload original document files');
            },
            onProgressEvent: (progress) => {
              setCurrentProgress(progress ?? 0);
            }
          }));
        } else {
          originalCallback();
        }
      };

      if (isNew) {
        dispatch(createDocument({
          body: {
            ...(body ?? {}),
            documentType: type.id,
            journey: body?.journey?.id ?? body?.journey?._id ?? body?.journey,
            internal: mustBeInternal ? true : undefined
          },
          onSuccess: (data) => {
            uploadFiles(data);
          },
          onError: (data) => {
            setIsUploading(false);
            setCurrentProgress(0);
            displayErrorMessage(data, 'Unable to create document');
          }
        }));
      } else if (document.documentType?.id === type.id && !(Object.keys(body ?? {})).length) {
        uploadFiles();
      } else {
        dispatch(updateDocument({
          documentId: document.id,
          body: {
            ...(body ?? {}),
            documentType: type.id,
            journey: body?.journey?.id ?? body?.journey?._id ?? body?.journey
          },
          onSuccess: () => {
            uploadFiles();
          },
          onError: (data) => {
            setIsUploading(false);
            setCurrentProgress(0);
            displayErrorMessage(data, 'Unable to update document');
          }
        }));
      }
    };

    const switchIsDoneState = (uid, groupIndex, itemIndex) => {
      setIsChecklistProcessing(true);
      const updatedChecklist = (deepClone(checklist)).map((it) => {
        return { ...it, isDone: uid === it.uid ? !it.isDone : !!it.isDone }
      });

      setChecklist(updatedChecklist);

      let groups = deepClone(groupedChecklist);
      groups[groupIndex].items[itemIndex].isDone = !groups[groupIndex].items[itemIndex].isDone;

      setGroupedChecklist(groups);
      if (checkBoxUpdateTimeoutId) clearTimeout(checkBoxUpdateTimeoutId);
      checkBoxUpdateTimeoutId = setTimeout(() => { doSave(null, null, null, null, updatedChecklist); setIsChecklistProcessing(false); }, 2500);
    };

    const updatePropertyAddress = (newAddress) => {
      if (!caseId) return;

      setPropertyAddress(newAddress);
      setIsPropertyValuationProcessing(true);

      if (propertyValuationUpdateTimeoutId) clearTimeout(propertyValuationUpdateTimeoutId);
      propertyValuationUpdateTimeoutId = setTimeout(() => {
        doSave(null, null, null, null, null, null, newAddress, undefined);
        setIsPropertyValuationProcessing(false);
      }, 2500);
    };

    const updateLender = (newLender) => {
      if (!caseId) return;

      setSelectedLender(newLender);
      setIsPropertyValuationProcessing(true);

      if (propertyValuationUpdateTimeoutId) clearTimeout(propertyValuationUpdateTimeoutId);
      propertyValuationUpdateTimeoutId = setTimeout(() => {
        doSave(null, null, null, null, null, null, undefined, newLender);
        setIsPropertyValuationProcessing(false);
      }, 2500);
    };

    const onManualAddressChange = (newAddress) => {
      setPropertyAddress(newAddress);

      if (!caseId) return;

      if (propertyValuationUpdateTimeoutId) clearTimeout(propertyValuationUpdateTimeoutId);
      propertyValuationUpdateTimeoutId = setTimeout(() => {
        setIsPropertyValuationProcessing(true);
        doSave(null, null, null, null, null, null, newAddress, undefined);
        setIsPropertyValuationProcessing(false);
      }, 2500);
    };

    const updatePreparePricingData = (overrides = {}, productsOverride) => {
      if (!caseId) return;

      // Prevent auto-save during initial data loading
      if (!isInitialDataLoaded) return;

      setIsLoadingPreparePricingData(true);
      const preparePricingData = {
        propertyAddress: propertyAddressRef.current,
        loanPurpose: pricingLoanPurposeRef.current,
        estimatedPrice: pricingEstimatedPriceRef.current,
        loanAmount: pricingLoanAmountRef.current,
        deposit: pricingDepositRef.current,
        firstHomeBuyer: pricingFirstHomeBuyerRef.current,
        reasonToBuy: pricingReasonToBuyRef.current,
        rateType: pricingRateTypeRef.current,
        fixedRateTerm: pricingFixedRateTermRef.current,
        repaymentType: pricingRepaymentTypeRef.current,
        loanTermValue: pricingLoanTermValueRef.current,
        loanTermUnit: pricingLoanTermUnitRef.current,
        selectedLenders: pricingSelectedLendersRef.current || [],
        selectedDeals: buildSelectedDealsFromProducts(productsOverride ?? selectedProductsRef.current),
        ...overrides
      };

      if (Array.isArray(preparePricingData.selectedLenders)) {
        preparePricingData.selectedLenders = preparePricingData.selectedLenders.filter(lender => lender !== null && lender !== undefined);
      }

      Object.keys(preparePricingData).forEach(key => {
        if (preparePricingData[key] === null) {
          delete preparePricingData[key];
        }
      });

      doSave(null, null, null, null, null, null, undefined, undefined, sanitizePreparePricing(preparePricingData));
    };

    const updatePreparePricingDataDebounced = (overrides = {}, productsOverride) => {
      if (!caseId) return;

      // Prevent auto-save during initial data loading
      if (!isInitialDataLoaded) return;

      if (preparePricingUpdateTimeoutId) clearTimeout(preparePricingUpdateTimeoutId);
      preparePricingUpdateTimeoutId = setTimeout(() => {
        setIsLoadingPreparePricingData(true);
        const preparePricingData = {
          propertyAddress: propertyAddressRef.current,
          loanPurpose: pricingLoanPurposeRef.current,
          estimatedPrice: pricingEstimatedPriceRef.current,
          loanAmount: pricingLoanAmountRef.current,
          deposit: pricingDepositRef.current,
          firstHomeBuyer: pricingFirstHomeBuyerRef.current,
          reasonToBuy: pricingReasonToBuyRef.current,
          rateType: pricingRateTypeRef.current,
          fixedRateTerm: pricingFixedRateTermRef.current,
          repaymentType: pricingRepaymentTypeRef.current,
          loanTermValue: pricingLoanTermValueRef.current,
          loanTermUnit: pricingLoanTermUnitRef.current,
          selectedLenders: pricingSelectedLendersRef.current || [],
          selectedDeals: buildSelectedDealsFromProducts(productsOverride ?? selectedProductsRef.current),
          ...overrides
        };

        if (Array.isArray(preparePricingData.selectedLenders)) {
          preparePricingData.selectedLenders = preparePricingData.selectedLenders.filter(lender => lender !== null && lender !== undefined);
        }

        Object.keys(preparePricingData).forEach(key => {
          if (preparePricingData[key] === null) {
            delete preparePricingData[key];
          }
        });

        doSave(null, null, null, null, null, null, undefined, undefined, sanitizePreparePricing(preparePricingData));
        // wait for updateCase response to reset the flag
      }, 2500);
    };

    const doDeleteLog = () => {
      const updateLogsList = () => {
        dispatch(getCaseTimeLogs({
          caseId,
          onSuccess: (data) => {
            setTimeLogs(data);
            setIsLogsLoading(false);
          },
          onError: (data) => {
            displayErrorMessage(data, 'Unable to retrieve action\'s time logs');
            setIsLogsLoading(false);
          }
        }));
      }

      setActionMenuPosition(null);
      setActionLogId(null);
      if (actionLogId) {
        setDeleteConfirmationParameters({
          entityType: 'time log',
          entityName: null,
          action: () => {
            setIsLogsLoading(true);
            dispatch(deleteCaseTimeLog({
              logId: actionLogId,
              onSuccess: () => {
                updateLogsList();
              },
              onError: (data) => {
                displayErrorMessage(data, 'Unable to delete the journey');
                updateLogsList();
              }
            }));
          }
        });

        setDeleteConfirmationOpen(true);
      }
    };

    const handleActionMenuOpen = (event, log) => {
      if (actionMenuPosition) return;

      event.preventDefault();
      setActionLogId(log.lastEntryId);
      setActionMenuPosition({
        top: event.clientY + 12,
        left: event.clientX + 12
      });
    };

    const getTimeStringFromMinutes = (minutes) => {
      const h = Math.floor((minutes ?? 0) / 60);
      const m = (minutes ?? 0) % 60;

      return `${h > 0 ? `${h}h ` : ''}${m < 10 ? '0' : ''}${m}m`;
    };

    const startTracking = () => {
      localStorage.setItem('timeTrackingAction', caseId);
      localStorage.setItem('timeTrackingActionName', effectiveUser?.name ? `${effectiveUser.name} ${effectiveUser.surname}` : 'undefined');
      localStorage.setItem('timeTrackingUser', effectiveUser?.id);
      localStorage.setItem('timeTrackingSeconds', '0');
      localStorage.setItem('timeTrackingLastUpdate', (Date.now()).toString());
      if (journey?.id) localStorage.setItem('timeTrackingJourney', journey.id);
      if (journey?.user?.id) localStorage.setItem('timeTrackingCustomer', journey.user.id);
      setActiveTimeTracker(caseId);
      setUserTracking(effectiveUser?.id);
    };

    const logTime = () => {
      if (!localStorage.getItem('timeTrackingSeconds') || !localStorage.getItem('timeTrackingAction') || !localStorage.getItem('timeTrackingUser')) {
        clearTimeTrackingInLocalStorage();
        setActiveTimeTracker(undefined);
        setUserTracking(undefined);
      } else {
        const minutes = Math.floor(Number(localStorage.getItem('timeTrackingSeconds') ?? 0) / 60);

        const clearAndUpdate = (data) => {
          clearTimeTrackingInLocalStorage();
          setActiveTimeTracker(undefined);
          setUserTracking(undefined);
          if (data) setTimeLogs([data, ...timeLogs]);
        };

        if (minutes > 0) {
          dispatch(createCaseTimeLog({
            body: {
              minutes,
              case: localStorage.getItem('timeTrackingAction'),
              user: localStorage.getItem('timeTrackingUser'),
              journey: journey?.id ?? undefined,
              customer: journey?.user?.id ?? undefined,
            },
            onSuccess: (data) => {
              clearAndUpdate(data);
            },
            onError: (data) => {
              displayErrorMessage(data, 'Unable to create the time log');
            },
          }));
        } else {
          clearAndUpdate();
        }
      }
    };

    const updateActionStatus = (status) => {
      setActionStatus(status);

      if (!!caseId && status !== currentActionState.caseStatus && (status !== 'ON HOLD' || (!!remindTime && !!reason))) {
        doSave(null, null, status);
      }
    };

    const createMarkup = (content) => {
      return {
        __html: content
      };
    };

    const renderActionMenu = (log, index) => {
      return (
        <Menu
          open={!!actionMenuPosition && log.lastEntryId === actionLogId}
          onClose={() => { setActionMenuPosition(null); setActionLogId(null); }}
          anchorReference="anchorPosition"
          anchorPosition={actionMenuPosition}
          data-testid={`actionmenu-actions-caseform-${index}`}
        >
          {([USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.OperationsManagerWithCurrentJourneyEditRights].includes(userRole) || log.user === effectiveUser?.id) && (<>
            <MenuItem
              onClick={() => { setActionMenuPosition(null); setActionLogId(null); onEditTimeLog(); }}
              disabled={!actionLogId || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing}
              data-testid={`menuitem-actions-caseform-edit-entry-${index}`}
            >
              Edit entry
            </MenuItem>

            <MenuItem className={styles.deleteMenuItem} onClick={() => doDeleteLog()} data-testid="menuitem-actions-caseform-delete">Delete</MenuItem>
          </>)}
        </Menu>
      );
    };

    const renderHistoryItem = (historyItem, index, isNew) => {
      const doc = isNew ? historyItem.meta?.document : reviewedJourneyDocuments.find((doc) => doc.id === historyItem.meta?.document);
      const docType = isNew ? documentTypes.find((dt) => dt.id === doc?.documentType) : doc?.documentType;

      const renderHistoryItemContent = () => {
        switch (historyItem.historyItemType) {
          case 'Assigned to':
            return (<div className={styles.text}>Assigned to {historyItem.meta?.assignedToName ?? '???'}</div>);
          case 'Attached file':
            return (<Grid container spacing={2} justifyContent={'space-between'} justifyItems={'space-between'} alignContent={'center'} alignItems={'center'}>
              <Grid item className={styles.type}>{docType?.category} / {docType?.type}</Grid>
              <Grid item>
                <Button color="primary" variant="contained" className={styles.smallButton} onClick={() => onViewDocument(doc)} data-testid={`button-actions-caseform-historyitem-view-${index}`}>
                  VIEW
                </Button>
              </Grid>
            </Grid>);
          case 'Commented':
            return (<div dangerouslySetInnerHTML={createMarkup(historyItem.meta?.comment ?? '')} />);
          case 'Status changed':
            return (<div className={styles.text}>
              <span>
                {`[${historyItem.meta?.oldStatus}] -> [${historyItem.meta?.newStatus}]`}
                {historyItem.meta?.remindTime ? `, remind on ${format(new Date(historyItem.meta?.remindTime), 'dd.MM.yyyy HH:mm')}` : ''}
              </span>
              {!!historyItem.meta?.comment && (<p className={`${styles.preWrap}`}>{historyItem.meta.comment}</p>)}
            </div>);
          case 'Checklist item marked':
            return (<div className={styles.text}>
              "{checklist.find((it) => it.uid === historyItem.meta?.checklistItemUID)?.title}"{' '}
              marked {`[${historyItem.meta?.oldIsDone ? 'DONE' : 'OPEN'}] -> [${historyItem.meta?.newIsDone ? 'DONE' : 'OPEN'}]`}
            </div>);
          case 'Priority changed':
            return (<div className={styles.text}>Priority set to {historyItem.meta?.newPriorityIsUrgent ? '"Urgent"' : '"Normal"'}</div>);
          case 'Action created':
          default:
            return null;
        }
      };

      const renderHistoryItemHeader = () => {
        return (<>
          {historyItem.createdAt ? `${format(new Date(historyItem.createdAt), 'dd.MM.yy HH:mm')} ` : ''}
          {historyItem.historyItemType === 'Commented' ? 'Commented' : null}
          {historyItem.historyItemType === 'Status changed' ? 'Status change' : null}
          {historyItem.historyItemType === 'Checklist item marked' ? 'Checklist updated' : null}
          {historyItem.historyItemType === 'Attached file' ? 'Attached file' : null}
          {historyItem.historyItemType === 'Assigned to' ? 'Assignee changed' : null}
          {historyItem.historyItemType === 'Action created' ? (historyItem.meta?.newPriorityIsUrgent ? 'Urgent action created' : 'Action created') : null}
          {historyItem.historyItemType === 'Priority changed' ? 'Priority changed' : null}
          {historyItem.createdByName ? ` by ${historyItem.createdByName}` : ''}

          {isNew && historyItem.historyItemType === 'Commented' && !caseId && (<IconButton
            aria-label="delete"
            onClick={() => { doDeleteComment(newHistory.length - 1 - index); }}
            className={styles.iconButton}
            data-testid={`iconbutton-actions-caseform-delete-comment-${index}`}
          >
            <DeleteForeverIcon />
          </IconButton>)}
          {isNew && historyItem.historyItemType === 'Attached file' && !caseId && (<IconButton
            aria-label="delete"
            onClick={() => { doDeleteDocument(newHistory.length - 1 - index); }}
            className={styles.iconButton}
            data-testid={`iconbutton-actions-caseform-delete-document-${index}`}
          >
            <DeleteForeverIcon />
          </IconButton>)}
        </>);
      }

      return (<React.Fragment key={index}>
        <Box mt={3} className={styles.historyItemHeader}>
          {renderHistoryItemHeader()}
        </Box>
        {historyItem.historyItemType === 'Commented' ? (
          <div className={`${styles.notesWrapper} ${styles.defaultEditor} ${styles.noTopBorderRadius}`}>
            {renderHistoryItemContent()}
          </div>
        ) : historyItem.historyItemType === 'Action created' ? null : (
          <Box className={`${styles.historyItemContent} ${historyItem.historyItemType === 'Attached file' ? styles.lighter : ''}`}>
            {renderHistoryItemContent()}
          </Box>
        )}
      </React.Fragment>);
    };



    const renderSelectedProduct = (product, index) => {
      const isFirst = index === 0;
      const docId = getDocumentIdFromValue(product.lenderApprovalDocument);
      const attachedFiles = product.lenderApprovalDocument?.files ?? [];
      const hasAttachedFile = attachedFiles.length > 0;

      const renderLenderApprovalBlock = () => {
        const lenderApprovalError = getProductFieldError(product, 'lenderApprovalDocument');

        return (
          <Box sx={{ mb: 2 }}>
            <FormRow label="Lender approval">
              <Grid item container className={docUploadStyles.buttonBlock} justifyContent="flex-end">
                <Button
                  color="secondary"
                  variant="outlined"
                  className={docUploadStyles.attachFilesButton}
                  onClick={() => openProductDocumentModal(product)}
                  disabled={disableLenderApprovalUpload || areProductsDisabled || (!caseId && !journey?.id)}
                  data-testid={`button-actions-caseform-upload-lender-approval-${index}`}
                >
                  <AttachmentIcon /> ATTACH FILES
                </Button>
              </Grid>
              {lenderApprovalError && (
                <ValidationErrorLabel errorMessage={lenderApprovalError} />
              )}
            </FormRow>

            {hasAttachedFile && attachedFiles.map((file, fileIdx) => (
              <Grid
                item
                container
                xs={12}
                className={docUploadStyles.fileItem}
                justifyContent="space-between"
                alignContent="center"
                alignItems="center"
                key={fileIdx}
              >
                <IconButton
                  aria-label="download"
                  onClick={() => { if (!disableLenderApprovalUpload) downloadProductFile(file, docId); }}
                  className={docUploadStyles.iconButton}
                  data-testid={`button-actions-caseform-download-file-${index}-${fileIdx}`}
                  disabled={disableLenderApprovalUpload}
                >
                  <CloudDownloadIcon />
                </IconButton>

                {isFilePreviewSupported(file) && (
                  <IconButton
                    aria-label="preview"
                    onClick={() => { if (!disableLenderApprovalUpload) previewProductFile(file); }}
                    className={docUploadStyles.iconButton}
                    data-testid={`button-actions-caseform-preview-file-${index}-${fileIdx}`}
                    disabled={disableLenderApprovalUpload}
                  >
                    <VisibilityIcon />
                  </IconButton>
                )}

                <Grid item className={docUploadStyles.name}>
                  <span
                    onClick={() => {
                      if (disableLenderApprovalUpload) return;
                      if (isFilePreviewSupported(file)) previewProductFile(file);
                      else downloadProductFile(file, docId);
                    }}
                    data-testid={`span-actions-caseform-product-file-${index}-${fileIdx}`}
                  >
                    {file.originalName}
                  </span>
                </Grid>

                <IconButton
                  aria-label="delete"
                  onClick={() => { if (!disableLenderApprovalUpload && !isActionCompleted) deleteProductFile(file, docId); }}
                  className={docUploadStyles.iconButton}
                  data-testid={`button-actions-caseform-delete-file-${index}-${fileIdx}`}
                  disabled={disableLenderApprovalUpload || isActionCompleted}
                >
                  <DeleteForeverIcon />
                </IconButton>
              </Grid>
            ))}
          </Box>
        );
      };

      return (
        <Grid item xs={12} key={product.id ?? index} style={{ marginBottom: '32px', borderTop: 'none', paddingTop: isFirst ? 0 : '24px' }}>

          <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '16px' }}>
            
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <Box className={styles.info} style={{ marginBottom: 0 }}>Product {index + 1}</Box>
              
              {isCreateMode && (
                <IconButton
                  className={styles.info}
                  aria-label="remove-product"
                  size="small"
                  onClick={() => handleRemoveSelectedProduct(product.id)}
                  data-testid={`button-actions-caseform-remove-product-${index}`}
                  disabled={areProductsDisabled}
                  style={{ marginLeft: '10px' }}
                >
                  <DeleteForeverIcon />
                </IconButton>
              )}
            </Grid>

            {(product?.dealId || product?.id) && (
              <Grid item>
                <div
                  className={`${styles.link} ${styles.tertiary}`}
                  style={{ marginBottom: 0 }}
                  onClick={() => navigateToProductDetails(product)}
                  data-testid={`link-actions-caseform-product-details-${index}`}
                >
                  View details
                </div>
              </Grid>
            )}
          </Grid>

          <Grid container justifyContent={'space-between'} alignItems="center" style={{ marginBottom: '16px' }}>
            <Grid item className={styles.info} xs={12} sm={4}>Lender</Grid>
            <Grid item className={styles.value} xs={12} sm={8} style={{ textAlign: dimensions.isScreenLessSM ? 'left' : 'right', fontWeight: 600 }}>
              {product.lenderName || '-'}
            </Grid>
          </Grid>

          <FormRow label="Product name">
            <TextField
              value={product.productName ?? ''}
              onChange={(e) => handleSelectedProductChange(product.id, 'productName', e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              style={{ backgroundColor: '#fff' }}
              disabled={areProductsDisabled}
              error={!!getProductFieldError(product, 'productName')}
              helperText={getProductFieldError(product, 'productName')}
            />
          </FormRow>

          <FormRow label="LMI (optional)">
            <TextField
              value={product.lmi ?? ''}
              onChange={(e) => handleSelectedProductChange(product.id, 'lmi', e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ inputComponent: DollarAmountFormat }}
              placeholder="$0.00"
              style={{ backgroundColor: '#fff' }}
              inputProps={{ 'data-testid': `input-actions-caseform-selected-lmi-${index}` }}
              disabled={areProductsDisabled}
            />
          </FormRow>

          <FormRow label="Preferred discounted rate">
            <TextField
              value={product.preferredDiscountedRate ?? ''}
              onChange={(e) => handleSelectedProductChange(product.id, 'preferredDiscountedRate', e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ inputComponent: PercentageFormat }}
              placeholder="0.00 %"
              style={{ backgroundColor: '#fff' }}
              inputProps={{ 'data-testid': `input-actions-caseform-preferred-rate-${index}` }}
              disabled={areProductsDisabled}
              error={!!getProductFieldError(product, 'preferredDiscountedRate')}
              helperText={getProductFieldError(product, 'preferredDiscountedRate')}
            />
        </FormRow>

        {!isCreateMode && (
          <FormRow label="Final discounted rate">
            <TextField
              value={product.finalDiscountedRate ?? ''}
              onChange={(e) => handleSelectedProductChange(product.id, 'finalDiscountedRate', e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ inputComponent: PercentageFormat }}
              placeholder="0.00 %"
              style={{ backgroundColor: '#fff' }}
              inputProps={{ 'data-testid': `input-actions-caseform-final-rate-${index}` }}
              disabled={disableFinalDiscountedRate || areProductsDisabled}
              error={!!getProductFieldError(product, 'finalDiscountedRate')}
              helperText={getProductFieldError(product, 'finalDiscountedRate')}
            />
          </FormRow>
        )}

          <FormRow label="Comments" alignTop>
            <EnhancedTextArea
              placeholder={''}
              multiline={'true'}
              minRows={4}
              maxRows={6}
              className={`${styles.textArea}`}
              value={product.comments ?? ''}
              onChange={(e) => handleSelectedProductChange(product.id, 'comments', e.target.value)}
              data-testid={`textarea-actions-caseform-product-comments-${index}`}
              disabled={areProductsDisabled}
            />

          </FormRow>

        {!isCreateMode && renderLenderApprovalBlock()}
        </Grid>
      );
    };

    const renderValuationFileBlock = () => {
      if (!isPropertyValuationType || !actionHasValuationFileField || isCreateMode) return null;

      const doc = valuationDocument;
      const docId = getDocumentIdFromValue(doc);
      const attachedFiles = doc?.files ?? [];
      const hasFiles = attachedFiles.length > 0 || (doc?.originalFiles?.length > 0);
      const isCompleted = isActionCompleted;

      if (isCompleted) {
        return (
          <Grid item xs={12}>
            <Grid container justifyContent={'space-between'} alignItems={'center'} className={styles.infoRow}>
              <Grid item className={styles.label} xs={4}>Valuation file</Grid>
              <Grid item className={styles.value} xs={8}>
                {hasFiles ? (
                  <Button
                    color="primary"
                    variant="contained"
                    className={styles.smallButton}
                    onClick={openValuationDocumentModal}
                    data-testid={`button-actions-caseform-view-valuation-file`}
                  >
                    VIEW
                  </Button>
                ) : '-'}
              </Grid>
            </Grid>
          </Grid>
        );
      }

      return (
        <Grid item xs={12}>
          <FormRow label="Valuation file">
            <Grid item container className={docUploadStyles.buttonBlock} justifyContent="flex-end">
              <Button
                color="secondary"
                variant="outlined"
                className={docUploadStyles.attachFilesButton}
                onClick={openValuationDocumentModal}
                disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing}
                data-testid={`button-actions-caseform-upload-valuation`}
              >
                <AttachmentIcon /> ATTACH FILES
              </Button>
            </Grid>
          </FormRow>

          {attachedFiles.map((file, fileIdx) => (
            <Grid
              item
              container
              xs={12}
              className={docUploadStyles.fileItem}
              justifyContent="space-between"
              alignContent="center"
              alignItems="center"
              key={fileIdx}
            >
              <IconButton
                aria-label="download"
                onClick={() => { downloadProductFile(file, docId); }}
                className={docUploadStyles.iconButton}
                data-testid={`button-actions-caseform-download-valuation-file-${fileIdx}`}
              >
                <CloudDownloadIcon />
              </IconButton>

              {isFilePreviewSupported(file) && (
                <IconButton
                  aria-label="preview"
                  onClick={() => { previewProductFile(file); }}
                  className={docUploadStyles.iconButton}
                  data-testid={`button-actions-caseform-preview-valuation-file-${fileIdx}`}
                >
                  <VisibilityIcon />
                </IconButton>
              )}

              <Grid item className={docUploadStyles.name}>
                <span
                  onClick={() => {
                    if (isFilePreviewSupported(file)) previewProductFile(file);
                    else downloadProductFile(file, docId);
                  }}
                  data-testid={`span-actions-caseform-valuation-file-${fileIdx}`}
                  style={{ cursor: 'pointer' }}
                >
                  {file.originalName}
                </span>
              </Grid>

              <IconButton
                aria-label="delete"
                onClick={() => { deleteValuationFile(file, docId); }}
                className={docUploadStyles.iconButton}
                data-testid={`button-actions-caseform-delete-valuation-file-${fileIdx}`}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Grid>
          ))}
        </Grid>
      );
    };

    const renderCompletedPropertyValuationBlock = () => {
      const doc = valuationDocument;
      const attachedFiles = doc?.files ?? [];
      const hasFiles = attachedFiles.length > 0 || (doc?.originalFiles?.length > 0);

      return (
        <Grid item xs={12}>
          {actionHasPropertyAddressField && (
            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
              <Grid item className={styles.label} xs={4}>Property address</Grid>
              <Grid item className={styles.value} xs={8}>
                {propertyAddress?.fullAddress || propertyAddress?.address || '-'}
              </Grid>
            </Grid>
          )}
          {shouldShowLenderField && (
            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
              <Grid item className={styles.label} xs={4}>Lender</Grid>
              <Grid item className={styles.value} xs={8}>
                {selectedLender?.name || '-'}
              </Grid>
            </Grid>
          )}
          {actionHasValuationFileField && (
            <Grid container justifyContent={'space-between'} alignItems={'center'} className={styles.infoRow}>
              <Grid item className={styles.label} xs={4}>Valuation file</Grid>
              <Grid item className={styles.value} xs={8}>
                {hasFiles ? (
                  <Button
                    color="primary"
                    variant="contained"
                    className={styles.smallButton}
                    onClick={openValuationDocumentModal}
                    data-testid={`button-actions-caseform-view-valuation-file`}
                  >
                    VIEW
                  </Button>
                ) : '-'}
              </Grid>
            </Grid>
          )}
        </Grid>
      );
    };

    const renderContent = () => {
      const primaryOwner = currentActionState?.journey?.user ?? currentActionState?.customer;

      return (<>
        <Box sx={{ mt: 2 }} >
          <Grid container spacing={4}>
            {!caseId ? (<>
              <Grid item xs={12}>
                <Box className={styles.info}>Action</Box>
                <FormControl variant="outlined" className={styles.selectWrapper}>
                  <Select
                    value={actionType}
                    displayEmpty
                    renderValue={(val) => !!actionType ? val.enrichedName : <span className={styles.placeholder}>Choose action</span>}
                    onChange={(e) => {
                      setActionType(e.target.value);
                      setInputTouched(2);
                    }}
                    SelectDisplayProps={{ 'data-testid': `select-display-actions-caseform-choose-action` }}
                  >
                    {actionTypeOptions.map((option) => {
                      return <MenuItem value={option} key={option.id} data-testid={`menuitem-actions-caseform-option-${option.enrichedName}`}><div>{option.enrichedName}</div></MenuItem>;
                    })}
                    {(!!actionTypeOptions?.length && !!customActionTypeOptions?.length) && <Divider />}
                    {customActionTypeOptions.map((option) => {
                      return <MenuItem value={option} key={option.id} data-testid={`menuitem-actions-caseform-custom-option-${option.enrichedName}`}><div>{option.enrichedName}</div></MenuItem>;
                    })}
                  </Select>
                  <ValidationErrorLabel errorMessage={ifValidationActive(2) && !actionType ? 'Action type is required' : ''} />
                </FormControl>
              </Grid>

              {(!!actionType || !!currentActionState?.typeObj) && (<>
                {isPreparePricingCreationRestricted && (
                  <Grid item xs={12}>
                    <div className={styles.warning}>
                      <Grid container justifyContent="space-between">
                        <Grid item className={styles.iconBlock}><ErrorIcon /></Grid>
                        <Grid item className={styles.textBlock}>
                          {ACTION_PERMISSION_ERROR}
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                )}

                {!journeyId && (<>
                  <Grid item xs={12}>
                    <Box className={styles.info}>Customer</Box>
                    <Autocomplete
                      options={journeyOwnerOptions}
                      getOptionLabel={(option) => `${option?.name}${option?.surname ? ' ' + option?.surname : ''}`}
                      fullWidth
                      value={journeyOwner ?? null}
                      isOptionEqualToValue={(option, value) => (option?.id ?? option?._id) === (value?.id ?? value?._id)}
                      onChange={(event, newValue) => {
                        setIsUpdatingJourneys(true);
                        setJourneyOwner(newValue);
                      }}
                      filterOptions={(options) => options}
                      disabled={!!journey || isChecklistProcessing || isPropertyValuationProcessing}
                      renderInput={(params) => <TextField
                        {...params}
                        style={{ backgroundColor: "white" }}
                        onChange={(event) => {
                          onJourneyOwnerSearchStringChanged(event.target.value);
                          setInputTouched(3);
                        }}
                        onFocus={(event) => {
                          if (!event.target.value) onJourneyOwnerSearchStringChanged(event.target.value);
                        }}
                        onBlur={() => setInputTouched(3)}
                        placeholder={`Choose associated customer${!!actionType?.custom || (!actionType?.customerRequired && !isPrepareRatesType && !isPropertyValuationType)
                          ? ' (optional)'
                          : ''
                          }`}
                        variant="outlined"
                        maxLength="100"
                        inputProps={{
                          ...(params.inputProps ?? {}),
                          'data-testid': `autocomplete-actions-caseform-customer`,
                          maxLength: 100,
                        }}
                      />}
                    />
                    <ValidationErrorLabel errorMessage={(ifValidationActive(3) && !journeyOwner && !actionType?.custom && (!!actionType?.customerRequired || isPrepareRatesType || isPropertyValuationType))
                      ? 'Customer is required for selected Action type'
                      : ''
                    } />
                  </Grid>

                  {!!journeyOwner && (
                    <Grid item xs={12}>
                      <Box className={styles.info}>Journey</Box>
                      <Autocomplete
                        options={journeyOptions}
                        getOptionLabel={(option) => `${option?.name}`}
                        fullWidth
                        value={journey ?? null}
                        disabled={isUpdatingJourneys || !journeyOwner || isChecklistProcessing || isPropertyValuationProcessing}
                        filterOptions={(options) => options}
                        onChange={(event, newValue) => {
                          setJourney(newValue);
                          if (newValue?.user) {
                            setJourneyOwner(newValue.user);
                          }
                          if (actionHasPropertyAddressField) {
                            setPropertyAddress(undefined);
                            setPropertyAddressInput('');
                          }
                          if (actionHasLenderField) {
                            setSelectedLender(undefined);
                          }
                        }}
                        renderInput={(params) => <TextField
                          {...params}
                          style={{ backgroundColor: "white" }}
                          value={journeySearchString}
                          onChange={(event) => {
                            onJourneySearchStringChanged(event.target.value);
                            setInputTouched(4);
                          }}
                          onFocus={(event) => {
                            if (!event.target.value) onJourneySearchStringChanged(event.target.value);
                          }}
                          onBlur={() => setInputTouched(4)}
                          placeholder={`Choose journey${!!actionType?.custom || !actionType?.customerRequired
                            ? ' (optional)'
                            : ''
                            }`}
                          variant="outlined"
                          maxLength="100"
                          inputProps={{
                            ...(params.inputProps ?? {}),
                            'data-testid': `autocomplete-actions-caseform-journey`,
                            maxLength: 100,
                          }}
                        />}
                      />
                      <ValidationErrorLabel errorMessage={(ifValidationActive(4) && !journey && !!journeyOwner)
                        ? `${!actionType?.custom && !!actionType?.customerRequired ? 'Journey is required for selected Action type' : ''}`
                        : ''
                      } />
                    </Grid>
                  )}
                </>)}
              </>)}
            </>) : (<>
              <Grid item xs={12}>
                {!!currentEditors?.length && (
                  <div className={styles.warning}>
                    <Grid container justifyContent="space-between">
                      <Grid item className={styles.iconBlock}><ErrorIcon /></Grid>
                      <Grid item className={styles.textBlock}>
                        Other user{currentEditors?.length === 1 ? '' : 's'} {currentEditors?.length === 1 ? 'is' : 'are'} viewing/editing this action:{' '}
                        {currentEditors.map((editor) => editor.editorName).filter(Boolean).join(', ')}
                      </Grid>
                    </Grid>
                  </div>
                )}
                <Grid container justifyContent={'space-between'}>
                  <Grid item className={`${styles.label} ${styles.pt1px}`} xs={4}>Age (Business hours)</Grid>
                  <Grid item className={styles.value} xs={8}>
                    <span className={styles.valueContent}>
                      {isTimeOutAlarm(
                        !!currentActionState?.createdAt ? new Date(currentActionState.createdAt) : undefined,
                        Number(currentActionState?.typeObj?.minutesToAlarm)
                      )
                        ? (
                          <Tooltip title={SLABreachedTooltip}>
                            <span className={styles.iconWrapper}>
                              <ErrorIcon className={styles.errorIcon} />
                            </span>
                          </Tooltip>
                        )
                        : isInQueueAlarm(!!currentActionState?.createdAt ? new Date(currentActionState.createdAt) : undefined)
                          ? (
                            <Tooltip title={queueSLABreachedTooltip}>
                              <span className={styles.iconWrapper}>
                                <ErrorOutlineIcon className={styles.errorIcon} />
                              </span>
                            </Tooltip>
                          )
                          : null}
                      {getElapsedTimeString(!!currentActionState?.createdAt ? new Date(currentActionState.createdAt) : undefined)}
                    </span>
                  </Grid>
                </Grid>
                <Grid container justifyContent={'space-between'}>
                  <Grid item className={styles.label} xs={4}>Date created</Grid>
                  <Grid item className={styles.value} xs={8}>
                    {!!currentActionState?.createdAt ? format(new Date(currentActionState.createdAt), 'dd.MM.yy HH:mm') : '-'}
                  </Grid>
                </Grid>
                {!!currentActionState?.journey ? (<>

                  {!!primaryOwner && (
                    <Grid container justifyContent={'space-between'}>
                      <Grid item className={styles.label} xs={4}>Primary owner</Grid>
                      <Grid
                        item
                        className={`${styles.value} ${styles.linkToDetails}`}
                        xs={8}
                      >
                        <a
                          href={`/profile/${primaryOwner?.id}`}
                          onClick={(e) => { e.preventDefault(); history.push(`/profile/${primaryOwner?.id}`); }}
                          data-testid={`link-actions-caseform-primary-owner`}
                        >
                          {primaryOwner?.name}{!!primaryOwner?.middlename ? ` ${primaryOwner.middlename}` : ''}{!!primaryOwner?.surname ? ` ${primaryOwner.surname}` : ''}
                        </a>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container justifyContent={'space-between'}>
                    <Grid item className={styles.label} xs={4}>Journey</Grid>
                    <Grid
                      item
                      className={`${styles.value} ${styles.linkToDetails}`}
                      xs={8}
                      onClick={() => history.push(getJourneyDetailsPath(currentActionState.journey))}
                    >
                      <a
                        href={getJourneyDetailsPath(currentActionState.journey)}
                        onClick={(e) => { e.preventDefault(); history.push(getJourneyDetailsPath(currentActionState.journey)); }}
                        data-testid={`link-actions-caseform-journey`}
                      >
                        {currentActionState.journey.name}
                      </a>
                    </Grid>
                  </Grid>
                </>) : (<>
                  {!!primaryOwner && (
                    <Grid container justifyContent={'space-between'}>
                      <Grid item className={styles.label} xs={4}>Customer</Grid>
                      <Grid
                        item
                        className={`${styles.value} ${styles.linkToDetails}`}
                        xs={8}
                      >
                        <a
                          href={`/profile/${primaryOwner?.id ?? primaryOwner?._id}`}
                          onClick={(e) => { e.preventDefault(); history.push(`/profile/${primaryOwner?.id ?? primaryOwner?._id}`); }}
                          data-testid={`link-actions-caseform-customer`}
                        >
                          {primaryOwner?.name}{!!primaryOwner?.middlename ? ` ${primaryOwner.middlename}` : ''}{!!primaryOwner?.surname ? ` ${primaryOwner.surname}` : ''}
                        </a>
                      </Grid>
                    </Grid>
                  )}
                </>)}
              </Grid>
            </>)}

            {(!!actionType || !!currentActionState?.typeObj) && (<>
              {(actionStatus === 'ON HOLD' && (currentActionState?.caseStatus !== 'ON HOLD' || (!!currentActionState?.remindTime && Math.abs((new Date(currentActionState.remindTime)).getTime() - remindTime.getTime()) > 60000))) && (<>
                <Grid item xs={12}>
                  <Box className={styles.info}>Reason</Box>
                  <EnhancedTextArea
                    placeholder="Input on hold reason here"
                    multiline={'true'}
                    minRows={3}
                    maxRows={3}
                    className={`${styles.textArea} ${ifValidationActive(5) && !reason.length ? styles.inputWithError : ''}`}
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                      setInputTouched(5);
                    }}
                    onBlur={() => { if (actionStatus === 'ON HOLD' && !!remindTime) doSave(); }}
                    disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                    data-testid={`textarea-actions-caseform-on-hold-reason`}
                  />
                  <ValidationErrorLabel errorMessage={ifValidationActive(5) && !reason.length ? 'Reason is required' : ''} />
                </Grid>
              </>)}

              {(actionStatus === 'ON HOLD') && (<>
                <Grid item xs={12} md={6}>
                  <Box className={styles.info}>Remind date and time</Box>
                  <LocalizationProvider dateAdapter={AdapterDateFns} locale={auLocale}>
                    <DateTimePicker
                      value={remindTime}
                      onChange={(date) => {
                        onChangeRemindTime(date, 6);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      minDate={new Date()}
                      onBlur={() => setInputTouched(6)}
                      style={{ width: '100%' }}
                      disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                      data-testid={`datetimepicker-actions-caseform-remind-time`}
                    />
                    <ValidationErrorLabel errorMessage={ifValidationActive(6) && !remindTime ? 'Remind date and time are required' : ''} />
                  </LocalizationProvider>
                </Grid>
              </>)}

              <Grid item xs={12}>
                <Box className={styles.info}>Assigned to</Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <FormControl variant="outlined" className={styles.selectWrapper}>
                      <Select
                        defaultValue={assignedTo ?? null}
                        value={assignedTo ?? null}
                        displayEmpty
                        style={{ backgroundColor: "white" }}
                        disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData || (!!assignedTo && actionStatus === 'COMPLETED')}
                        SelectDisplayProps={{ 'data-testid': `select-actions-caseform-assigned-to` }}
                      >
                        <MenuItem
                          value={null}
                          style={!assignedTo ? { display: 'none' } : {}}
                          onClick={() => { setAssignedTo(null); setInputTouched(7); if (!!caseId) doSave(null, 'null'); }}
                          key={-1}
                          disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                          data-testid={`menuitem-actions-caseform-${assignedTo ? ('Clear selection') : ('Choose assignee')}`}
                        >
                          <div style={{ textTransform: "none", color: '#8B90A0' }}>{assignedTo ? ('Clear selection') : ('Choose assignee')}</div>
                        </MenuItem>
                        {(assigneeOptions ?? []).map((option, idx) => {
                          return (
                            <MenuItem
                              value={option}
                              key={idx}
                              onClick={() => { setAssignedTo(option); setInputTouched(7); if (!!caseId) doSave(null, option); }}
                              disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                              data-testid={`menuitem-actions-caseform-option-${idx}`}
                            >
                              <div style={{ textTransform: "none" }}>{option.name} {option.surname}</div>
                            </MenuItem>
                          )
                        })}
                      </Select>
                      <ValidationErrorLabel errorMessage={actionStatus === 'COMPLETED' && !assignedTo ? 'Action can\'t be "COMPLETED" with no assignee' : ''} />
                    </FormControl>
                    {(dimensions.isScreenLessMD && isUserInSpecialistsList()) && (<>
                      <Grid container justifyItems={'flex-end'} justifyContent={'flex-end'}>
                        <Grid item className={`${styles.link} ${!!caseId && (isEditingComment || isEditingNotes) ? styles.disabled : ''}`} data-testid={`link-actions-caseform-assign-to-me`} onClick={() => {
                          if (!caseId || !(isEditingComment || isEditingNotes)) {
                            doAssignToMe();
                            setInputTouched(7);
                          }
                        }}>
                          Assign to me
                        </Grid>
                      </Grid>
                    </>)}
                  </Grid>
                  <Grid item xs={12} md={8} container justifyContent={'space-between'}>
                    {(!dimensions.isScreenLessSM) && (
                      <Grid item xs={4}>
                        {(!dimensions.isScreenLessMD && isUserInSpecialistsList()) && (
                          <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={() => { doAssignToMe(); setInputTouched(7); }}
                            disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                            data-testid={`button-actions-caseform-assign-to-me`}
                          >
                            ASSIGN TO ME
                          </Button>
                        )}
                      </Grid>
                    )}
                    <Grid item container spacing={2} justifyContent={'flex-end'} xs={12} md={8}>
                      <Grid item className={`${styles.fullWidthOnXS} ${styles.halfWideOnMd}`}>
                        {!!activeTimeTracker ? (
                          <Button
                            type="button"
                            variant="outlined"
                            color="secondary"
                            className={styles.logTimeButton}
                            onClick={() => { logTime(); }}
                            disabled={userTracking !== effectiveUser?.id || activeTimeTracker !== caseId}
                            data-testid={`button-actions-caseform-stop-and-log`}
                          >
                            STOP & LOG<span className={`${styles.afterInscriptionIcon} ${styles.stop}`}><StopIcon /></span>
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            variant="outlined"
                            color="secondary"
                            className={styles.logTimeButton}
                            onClick={() => { startTracking(); }}
                            data-testid={`button-actions-caseform-start`}
                          >
                            START<span className={`${styles.afterInscriptionIcon} ${styles.start}`}><PlayArrowIcon /></span>
                          </Button>
                        )}
                      </Grid>
                      <Grid item className={`${styles.fullWidthOnXS} ${styles.halfWideOnMd}`}>
                        <Button
                          type="button"
                          variant="outlined"
                          color="secondary"
                          className={styles.logTimeButton}
                          onClick={() => { onCreateTimeLog(); }}
                          data-testid={`button-actions-caseform-log-time`}
                        >
                          LOG TIME<span className={styles.afterInscriptionIcon}><AvTimerIcon /></span>
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} container justifyContent="flex-start">
                    <Grid item className={styles.switcherWrapper}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={urgent}
                            onChange={(e) => {
                              if (!!caseId) {
                                doSave(null, undefined, undefined, undefined, undefined, !urgent);
                                onUrgentChange(e);
                              } else {
                                onUrgentChange(e);
                              }
                            }}
                            disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPreparePricingData}
                            name="isAgree"
                            color="primary"
                            data-testid={`switch-actions-caseform-urgent`}
                          />
                        }
                        label={''}
                      />
                    </Grid>
                    <Grid item className={styles.switcherLabelWrapper}>
                      <Box sx={{ width: '100%' }} className={styles.label}>
                        Urgent – Immediate action required
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>)}

            {actionHasPropertyAddressField && (!!journeyOwner || !!caseId) && (<>
              <Grid item xs={12}>
                <Grid container justifyContent={'space-between'} alignContent={'center'} alignItems={'center'} className={styles.subtitleWrapper}>
                  <Grid item className={styles.subtitle}>
                    {isPropertyValuationType ? 'Property details' : 'Loan details'}
                  </Grid>
                </Grid>
              </Grid>
              {(!caseId || !actionHasFinancialFields) && !(isPropertyValuationType && isActionCompleted) && (
                  <Grid item xs={12}>
                    <Box className={styles.info}>
                      {isPrepareRatesType
                        ? 'Property address'
                        : ((actionType?.hasDealPricingFields || currentActionState?.typeObj?.hasDealPricingFields) ||
                          (actionType?.hasDealLendersField || currentActionState?.typeObj?.hasDealLendersField))
                          ? 'What is the address of this property?'
                          : 'What is the address of this property for valuation?'}
                    </Box>
                    {isCustomAddress ? (
                      <TextField
                        value={propertyAddress?.fullAddress ?? ''}
                        onChange={(e) => {
                          const newAddress = { ...propertyAddress, fullAddress: e.target.value, country: 'Australia' };
                          onManualAddressChange(newAddress);
                        }}
                        onBlur={() => {
                          setPricingTouched(8);
                        }}
                        fullWidth
                        variant="outlined"
                        name="propertyAddress"
                        error={ifValidationActive(8) && !propertyAddress?.fullAddress}
                        helperText={ifValidationActive(8) && !propertyAddress?.fullAddress ? 'Property address is required' : ''}
                        placeholder="Type address here"
                        disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPropertyValuationData}
                        inputProps={{ 'data-testid': 'input-actions-caseform-property-address-manual', maxLength: 500 }}
                      />
                    ) : (
                      <Autocomplete
                        options={addressOptions}
                        getOptionLabel={(option) => option.fullAddress || option.address}
                        filterOptions={(options) => options}
                        value={propertyAddress ?? null}
                        onChange={(event, newValue) => {
                          if (caseId) {
                            updatePropertyAddress(newValue);
                          } else {
                            setPropertyAddress(newValue);
                          }
                          setPricingTouched(8);
                        }}
                        disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPropertyValuationData}
                        renderInput={(params) => <TextField
                          {...params}
                          value={propertyAddressInput}
                          onChange={(event) => {
                            onAddressInputChanged(event.target.value);
                          }}
                          onFocus={(event) => {
                            if (!event.target.value) onAddressInputChanged(event.target.value);
                          }}
                          onBlur={() => {
                            setPricingTouched(8);
                          }}
                          placeholder="Choose property address"
                          variant="outlined"
                          error={ifValidationActive(8) && !propertyAddress}
                          helperText={ifValidationActive(8) && !propertyAddress ? 'Property address is required' : ''}
                          inputProps={{
                            ...(params.inputProps ?? {}),
                            'data-testid': 'input-actions-caseform-property-address',
                            maxLength: 500,
                          }}
                        />}
                      />
                    )}
                    <div className={`${styles.link} ${(!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPropertyValuationData) ? styles.disabled : ''}`}>
                      <span
                        onClick={() => {
                          if (!inProgress && !isChecklistProcessing && !isPropertyValuationProcessing && !isLoadingPropertyValuationData) {
                            onModeChange();
                          }
                        }}
                        data-testid="span-actions-caseform-address-mode-toggle"
                      >
                        {isCustomAddress ? 'Choose address from the list' : 'Provide address manually'}
                      </span>
                    </div>
                  </Grid>
              )}
            </>)}

            {shouldShowLenderField && (!caseId || !actionHasFinancialFields) && (!!journeyOwner || !!caseId) && !(isPropertyValuationType && isActionCompleted) && (
                <Grid item xs={12}>
                  <Box className={styles.info}>What's the lender?</Box>
                  <Autocomplete
                    options={lenderOptions}
                    getOptionLabel={(option) => option?.name ?? ''}
                    filterOptions={(options) => options}
                    value={selectedLender ?? null}
                    onChange={(event, newValue) => {
                      if (caseId) {
                        updateLender(newValue);
                      } else {
                        setSelectedLender(newValue);
                      }
                      setInputTouched(9);
                    }}
                    noOptionsText={noLenderOptionsText}
                    disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isLoadingPropertyValuationData}
                    renderInput={(params) => <TextField
                      {...params}
                      onChange={(event) => {
                        onLenderInputChanged(event.target.value);
                      }}
                      onFocus={(event) => {
                        if (!event.target.value) onLenderInputChanged(event.target.value);
                      }}
                      onBlur={() => {
                        setInputTouched(9);
                      }}
                      placeholder="Choose a lender"
                      variant="outlined"
                      error={ifValidationActive(9) && !selectedLender}
                      helperText={ifValidationActive(9) && !selectedLender ? 'Lender is required' : ''}
                      inputProps={{
                        ...(params.inputProps ?? {}),
                        'data-testid': 'input-actions-caseform-lender',
                        maxLength: 100,
                      }}
                    />}
                  />
                </Grid>
            )}

            {(!!journeyOwner || !!caseId) && (isPropertyValuationType && isActionCompleted) && renderCompletedPropertyValuationBlock()}

            {(!!journeyOwner || !!caseId) && !isActionCompleted && renderValuationFileBlock()}

            {actionHasFinancialFields && (!!journeyOwner || !!caseId) && (<>
              {!!caseId ? (
                <Grid item xs={12}>
                  {actionHasPropertyAddressField && (
                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Property address</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {propertyAddress?.fullAddress || propertyAddress?.address || '-'}
                      </Grid>
                    </Grid>
                  )}

                  {shouldShowLenderField && (
                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Lender</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {selectedLender?.name || '-'}
                      </Grid>
                    </Grid>
                  )}

                  <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                    <Grid item className={styles.label} xs={4}>Loan type</Grid>
                    <Grid item className={styles.value} xs={8}>
                      {pricingLoanPurpose || '-'}
                    </Grid>
                  </Grid>

                  {pricingLoanPurpose && (<>
                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Property price</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {formatCurrency(pricingEstimatedPrice)}
                      </Grid>
                    </Grid>

                    {pricingLoanPurpose === 'Purchase' && (
                      <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                        <Grid item className={styles.label} xs={4}>Deposit</Grid>
                        <Grid item className={styles.value} xs={8}>
                          {formatCurrency(pricingDeposit)}
                        </Grid>
                      </Grid>
                    )}

                    {pricingLoanPurpose === 'Refinance' && (
                      <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                        <Grid item className={styles.label} xs={4}>Loan amount</Grid>
                        <Grid item className={styles.value} xs={8}>
                          {formatCurrency(pricingLoanAmount)}
                        </Grid>
                      </Grid>
                    )}

                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Property purpose</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {pricingReasonToBuy || '-'}
                      </Grid>
                    </Grid>

                    {pricingReasonToBuy === 'Owner Occupied' && (
                      <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                        <Grid item className={styles.label} xs={4}>First home buyer</Grid>
                        <Grid item className={styles.value} xs={8}>
                          {pricingFirstHomeBuyer || '-'}
                        </Grid>
                      </Grid>
                    )}

                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Rate type</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {pricingRateType || '-'}
                      </Grid>
                    </Grid>

                    {pricingRateType === 'Fixed' && (
                      <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                        <Grid item className={styles.label} xs={4}>Fixed term rate</Grid>
                        <Grid item className={styles.value} xs={8}>
                          {pricingFixedRateTerm ? `${pricingFixedRateTerm / 12} ${pricingFixedRateTerm / 12 === 1 ? 'year' : 'years'}` : '-'}
                        </Grid>
                      </Grid>
                    )}

                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Repayment type</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {pricingRepaymentType || '-'}
                      </Grid>
                    </Grid>

                    <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                      <Grid item className={styles.label} xs={4}>Loan term</Grid>
                      <Grid item className={styles.value} xs={8}>
                        {pricingLoanTermValue ? `${pricingLoanTermValue} ${pricingLoanTermUnit}` : '-'}
                      </Grid>
                    </Grid>
                  </>)}
                </Grid>
              ) : (
                <>
                  <Grid item xs={12}>
                    <Box className={styles.info}>Loan type</Box>
                    <RadioButtonGroup
                      onChange={(v) => {
                        setPricingLoanPurpose(v);
                        setPricingTouched(11);
                        updatePreparePricingData({ loanPurpose: v });
                      }}
                      onBlur={() => setPricingTouched(11)}
                      options={[
                        { value: 'Purchase', label: 'PURCHASE', size: dimensions.isScreenBiggerXS ? 200 : 100 },
                        { value: 'Refinance', label: 'REFINANCE', size: dimensions.isScreenBiggerXS ? 200 : 100 }
                      ]}
                      defaultValue={pricingLoanPurpose}
                      disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                      groupTestId="radiogroup-pricing-reason"
                    />
                    <ValidationErrorLabel errorMessage={ifValidationActive(11) && !pricingLoanPurpose ? 'Loan purpose is required' : ''} />
                  </Grid>

                  {pricingLoanPurpose && (<>
                    <Grid item xs={12}>
                      <Box className={styles.info}>Property price</Box>
                      <TextField
                        value={pricingEstimatedPrice}
                        onChange={(e) => {
                          const val = e.target.value;
                          setPricingEstimatedPrice(val);
                          pricingEstimatedPriceRef.current = val;
                          setPricingTouched(12);
                          updatePreparePricingDataDebounced({ estimatedPrice: val });
                        }}
                        onBlur={() => setPricingTouched(12)}
                        fullWidth
                        variant="outlined"
                        InputProps={{ inputComponent: DollarAmountFormat }}
                        placeholder="e.g. $1,200,000.00"
                        error={ifValidationActive(12) && !pricingEstimatedPrice}
                        helperText={ifValidationActive(12) && !pricingEstimatedPrice ? 'Estimated property price is required' : ''}
                        disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                        inputProps={{ 'data-testid': 'input-actions-caseform-pricing-estimated-price' }}
                      />
                    </Grid>

                    {pricingLoanPurpose === 'Purchase' && (
                      <Grid item xs={12}>
                        <Box className={styles.info}>Deposit</Box>
                        <TextField
                          value={pricingDeposit}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPricingDeposit(val);
                            pricingDepositRef.current = val;
                            setPricingTouched(20);
                            updatePreparePricingDataDebounced({ deposit: val });
                          }}
                          onBlur={() => setPricingTouched(20)}
                          fullWidth
                          variant="outlined"
                          InputProps={{ inputComponent: DollarAmountFormat }}
                          placeholder="e.g. $80,000.00"
                          error={ifValidationActive(20) && !pricingDeposit}
                          helperText={ifValidationActive(20) && !pricingDeposit ? 'Deposit amount is required' : ''}
                          disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                          inputProps={{ 'data-testid': 'input-actions-caseform-pricing-deposit' }}
                        />
                      </Grid>
                    )}

                    {pricingLoanPurpose === 'Refinance' && (<>
                      <Grid item xs={12}>
                        <Box className={styles.info}>Loan amount</Box>
                        <TextField
                          value={pricingLoanAmount}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPricingLoanAmount(val);
                            pricingLoanAmountRef.current = val;
                            setPricingTouched(13);
                            updatePreparePricingDataDebounced({ loanAmount: val });
                          }}
                          onBlur={() => setPricingTouched(13)}
                          fullWidth
                          variant="outlined"
                          InputProps={{ inputComponent: DollarAmountFormat }}
                          placeholder="e.g. $200,000.00"
                          error={ifValidationActive(13) && !pricingLoanAmount}
                          helperText={ifValidationActive(13) && !pricingLoanAmount ? 'Loan amount is required' : ''}
                          disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                          inputProps={{ 'data-testid': 'input-actions-caseform-pricing-loan-amount' }}
                        />
                      </Grid>
                    </>)}

                    <Grid item xs={12}>
                      <Box className={styles.info}>Property purpose</Box>
                      <RadioButtonGroup
                        onChange={(v) => {
                          setPricingReasonToBuy(v);
                          setPricingTouched(15);
                          updatePreparePricingData({ reasonToBuy: v });
                        }}
                        onBlur={() => setPricingTouched(15)}
                        options={[
                          { value: 'Owner Occupied', label: 'TO LIVE IN', size: dimensions.isScreenBiggerXS ? 200 : 100 },
                          { value: 'Investment', label: 'TO INVEST', size: dimensions.isScreenBiggerXS ? 200 : 100 }
                        ]}
                        defaultValue={pricingReasonToBuy}
                        disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                        groupTestId="radiogroup-pricing-loan-purpose"
                      />
                      <ValidationErrorLabel errorMessage={ifValidationActive(15) && !pricingReasonToBuy ? 'Reason to buy is required' : ''} />
                    </Grid>

                    {pricingReasonToBuy === 'Owner Occupied' && (
                      <Grid item xs={12}>
                        <Box className={styles.info}>First home buyer</Box>
                        <RadioButtonGroup
                          onChange={(v) => {
                            setPricingFirstHomeBuyer(v);
                            setPricingTouched(14);
                            updatePreparePricingData({ firstHomeBuyer: v });
                          }}
                          onBlur={() => setPricingTouched(14)}
                          options={[
                            { value: 'YES', label: 'YES', size: dimensions.isScreenBiggerXS ? 200 : 100 },
                            { value: 'NO', label: 'NO', size: dimensions.isScreenBiggerXS ? 200 : 100 }
                          ]}
                          defaultValue={pricingFirstHomeBuyer}
                          disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                          groupTestId="radiogroup-pricing-first-home-buyer"
                        />
                        <ValidationErrorLabel errorMessage={ifValidationActive(14) && !pricingFirstHomeBuyer ? 'First home buyer selection is required' : ''} />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Box className={styles.info}>Rate type</Box>
                      <Tooltip
                        open={activeHint === 'RateType'}
                        title={rateTypeHint}
                        placement={dimensions.isScreenXS ? undefined : 'right'}
                      >
                        <RadioButtonGroup
                          onChange={(v) => {
                            setPricingRateType(v);
                            setPricingTouched(16);
                            updatePreparePricingData({ rateType: v });
                            if (v !== 'Fixed') {
                              setPricingFixedRateTerm('');
                            }
                          }}
                          onBlur={() => setPricingTouched(16)}
                          options={[
                            { value: 'Variable', label: 'VARIABLE', size: dimensions.isScreenBiggerXS ? 200 : 100 },
                            { value: 'Fixed', label: 'FIXED', size: dimensions.isScreenBiggerXS ? 200 : 100 }
                          ]}
                          defaultValue={pricingRateType}
                          disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                          groupTestId="radiogroup-pricing-rate-type"
                        />
                      </Tooltip>
                      <ValidationErrorLabel errorMessage={ifValidationActive(16) && !pricingRateType ? 'Rate type is required' : ''} />
                    </Grid>

                    {pricingRateType === 'Fixed' && (
                      <Grid item xs={12}>
                        <Box className={styles.info}>Fixed term rate</Box>
                        <Tooltip
                          open={activeHint === 'FixedRateTerm'}
                          title={fixedRateTermHint}
                          placement={dimensions.isScreenXS ? undefined : 'right'}
                        >
                          <RadioButtonGroup
                            onChange={(v) => {
                              setPricingFixedRateTerm(v);
                              setPricingTouched(17);
                              updatePreparePricingData({ fixedRateTerm: v });
                            }}
                            onBlur={() => setPricingTouched(17)}
                            options={[
                              { value: '12', label: '1 YEAR', size: dimensions.isScreenBiggerXS ? 100 : 50 },
                              { value: '24', label: '2 YEARS', size: dimensions.isScreenBiggerXS ? 100 : 50 },
                              { value: '36', label: '3 YEARS', size: dimensions.isScreenBiggerXS ? 100 : 50 },
                              { value: '48', label: '4 YEARS', size: dimensions.isScreenBiggerXS ? 100 : 50 },
                              { value: '60', label: '5 YEARS', size: dimensions.isScreenBiggerXS ? 100 : 50 }
                            ]}
                            defaultValue={pricingFixedRateTerm}
                            disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                            groupTestId="radiogroup-pricing-fixed-rate-term"
                          />
                        </Tooltip>
                        <ValidationErrorLabel errorMessage={ifValidationActive(17) && pricingRateType === 'Fixed' && !pricingFixedRateTerm ? 'Fixed rate term is required' : ''} />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Box className={styles.info}>Repayment type</Box>
                      <RadioButtonGroup
                        onChange={(v) => {
                          setPricingRepaymentType(v);
                          setPricingTouched(18);
                          updatePreparePricingData({ repaymentType: v });
                        }}
                        onBlur={() => setPricingTouched(18)}
                        options={[
                          { value: 'Principal & Interest', label: 'PRINCIPAL & INTEREST', size: dimensions.isScreenBiggerXS ? 200 : 100 },
                          { value: 'Interest only', label: 'INTEREST ONLY', size: dimensions.isScreenBiggerXS ? 200 : 100 }
                        ]}
                        defaultValue={pricingRepaymentType}
                        disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                        groupTestId="radiogroup-pricing-repayment-type"
                      />
                      <ValidationErrorLabel errorMessage={ifValidationActive(18) && !pricingRepaymentType ? 'Repayment type is required' : ''} />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={styles.info}>Loan term</Box>
                      <InputWithSelect
                        style={{ width: dimensions.isScreenLessMD ? '100%' : `${2 * (dimensions.isScreenBiggerXS ? 200 : 100)}px` }}
                        placeholder="0"
                        value={pricingLoanTermValue}
                        onChange={(e) => {
                          const val = e.target?.value;
                          setPricingLoanTermValue(val);
                          pricingLoanTermValueRef.current = val;
                          setPricingTouched(21);
                          updatePreparePricingDataDebounced({ loanTermValue: val });
                        }}
                        onBlur={() => setPricingTouched(21)}
                        selectWidth={140}
                        selectValue={pricingLoanTermUnit}
                        onSelect={(e) => {
                          const val = e.target?.value;
                          setPricingLoanTermUnit(val);
                          pricingLoanTermUnitRef.current = val;
                          setPricingTouched(21);
                          updatePreparePricingDataDebounced({ loanTermUnit: val });
                        }}
                        options={[
                          { value: 'years', label: 'Years' },
                          { value: 'months', label: 'Months' }
                        ]}
                        InputProps={{
                          inputComponent: PositiveIntegerFormat
                        }}
                        disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                        selectDisabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                        className={ifValidationActive(21) && !pricingLoanTermValue ? styles.inputWithError : ''}
                        inputTestId="input-actions-caseform-pricing-loan-term"
                        selectTestId="select-actions-caseform-pricing-loan-term-unit"
                      />
                      <ValidationErrorLabel errorMessage={ifValidationActive(21) && !pricingLoanTermValue ? 'Loan term is required' : ''} />
                    </Grid>
                  </>)}
                </>
              )}
            </>)}

            {actionHasFinancialAssessmentFields && (
              <>
                <Grid item xs={12}>
                  <Grid container justifyContent={'space-between'} alignContent={'center'} alignItems={'center'} className={styles.subtitleWrapper}>
                    <Grid item className={styles.subtitle}>
                      Products (max {getMaxSelectableProducts()})
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {selectedProducts?.length ? (
                    isActionCompleted ? (
                      // READ-ONLY VIEW (Action Completed)
                      selectedProducts.map((product, idx) => {
                        const docId = getDocumentIdFromValue(product.lenderApprovalDocument);
                        const attachedFiles = product.lenderApprovalDocument?.files ?? [];
                        
                        return (
                          // 1. Applied productBlock (32px bottom margin)
                          <Grid item xs={12} key={product.id ?? idx} className={styles.productBlock}> 
                            
                            {/* 2. Applied productBlockHeader (16px bottom margin) */}
                            <Grid container justifyContent={'space-between'} alignItems={'center'}>
                              <Grid item>
                                <Box className={styles.info} style={{ marginBottom: 0 }}>Product {idx + 1}</Box>
                              </Grid>
                              {(product?.dealId || product?.id) && (
                                <Grid item>
                                  <div
                                    className={`${styles.link} ${styles.tertiary} ${styles.mb16}`}
                                    onClick={() => navigateToProductDetails(product)}
                                    data-testid={`link-actions-caseform-product-details-${idx}`}
                                  >
                                    View details
                                  </div>
                                </Grid>
                              )}
                            </Grid>
                            
                            {/* 3. Applied infoRow (8px bottom margin) to all data rows */}
                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Lender</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {product.lenderName || '-'}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Product name</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {product.productName || '-'}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>LMI</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {formatCurrency(product.lmi)}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Preferred discounted rate</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {product.preferredDiscountedRate ? `${product.preferredDiscountedRate} %` : '-'}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Final discounted rate</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {product.finalDiscountedRate ? `${product.finalDiscountedRate} %` : '-'}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Comments</Grid>
                              <Grid item className={styles.value} xs={8} style={{ whiteSpace: 'pre-wrap' }}>
                                {product.comments || '-'}
                              </Grid>
                            </Grid>

                            <Grid container justifyContent={'space-between'} alignItems={'center'} className={styles.infoRow}>
                              <Grid item className={styles.label} xs={4}>Lender approval</Grid>
                              <Grid item className={styles.value} xs={8}>
                                {(product.lenderApprovalDocument?.files?.length > 0 || product.lenderApprovalDocument?.originalFiles?.length > 0) ? (
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      className={styles.smallButton}
                                      onClick={() => openProductDocumentModal(product)}
                                      data-testid={`button-actions-caseform-product-view-doc-${idx}`}
                                    >
                                      VIEW
                                    </Button>
                                ) : '-'}
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })
                    ) : (
                      // EDIT VIEW (Action In Progress/Created)
                      selectedProducts.map((product, idx) => (
                        <Grid item xs={12} key={product.id ?? idx}>
                          {renderSelectedProduct(product, idx)}
                        </Grid>
                      ))
                    )
                  ) : (
                    <Grid container justifyContent={'center'} justifyItems={'center'}>
                      <Grid item className={styles.emptyLabel}>No products added yet</Grid>
                    </Grid>
                  )}
                </Grid>

                {isCreateMode && !!getProductValidationMessage() && (
                  <Grid item xs={12}>
                    <ValidationErrorLabel errorMessage={getProductValidationMessage()} />
                  </Grid>
                )}

                {isCreateMode && canLaunchDealFinder() && (
                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      onClick={handleAddProductClick}
                      disabled={!!inProgress || isChecklistProcessing || isLoadingPreparePricingData}
                      data-testid="button-actions-caseform-add-product"
                    >
                      ADD PRODUCT
                    </Button>
                  </Grid>
                )}
              </>
            )}

            {!!aggregatedTimeLogs?.length && (
              <Grid item xs={12}>
                <Box className={styles.info}>Time log</Box>
                <Grid container>
                  <Grid item xs={12} className={`${styles.aggregatedTimeLogTableWrapper} ActionTimeLogTableInCaseForm`}>
                    <TableContainer className={`${styles.tableContainer} ${styles.fixedWidth}`}>
                      <Table size={dimensions.isScreenBiggerSM ? "medium" : "small"} stickyHeader>
                        <TableHead>
                          <TableRow className={styles.tableHead}>
                            <TableCell align={'left'} style={{ minWidth: 220 }}>USER</TableCell>
                            <TableCell align={'left'} style={{ minWidth: 120 }}>LAST TIMER DATE</TableCell>
                            <TableCell align={'left'} style={{ minWidth: 96 }}>LAST ENTRY</TableCell>
                            <TableCell align={'left'} style={{ minWidth: 120 }}>TOTAL TIME SPENT</TableCell>
                            <TableCell align={'right'} style={{ minWidth: 10, width: 10 }} />
                          </TableRow>
                        </TableHead>

                        <TableBody className={styles.tableBody}>
                          {(aggregatedTimeLogs ?? []).map((log, idx) => {
                            return (
                              <TableRow className={styles.tableItem} key={idx}>
                                <TableCell align={'left'} className={styles.name}>
                                  {log.userName}
                                </TableCell>

                                <TableCell align={'left'} className={styles.date}>
                                  {log.lastTimerDate ? format(new Date(log.lastTimerDate), 'dd.MM.yyyy HH:mm') : '???'}
                                </TableCell>

                                <TableCell align={'left'} className={styles.name}>
                                  {getTimeStringFromMinutes(log.lastEntry)}
                                </TableCell>

                                <TableCell align={'left'} className={styles.name}>
                                  {getTimeStringFromMinutes(log.totalTime)}
                                </TableCell>

                                <TableCell align={'left'}>
                                  {([USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.OperationsManagerWithCurrentJourneyEditRights].includes(userRole) || log.user === effectiveUser?.id) && (<>
                                    <IconButton
                                      className={`${styles.iconBtn} ${styles.noPadding}`}
                                      onClick={(event) => { handleActionMenuOpen(event, log); }}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    {renderActionMenu(log, idx)}
                                  </>)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      {(isLogsLoading) && (<CircularProgress size={40} className={`${styles.cardProgress} ${styles.timeLog}`} />)}
                    </TableContainer>
                    <Grid container justifyItems={'flex-end'} justifyContent={'flex-end'}>
                      <Grid item>
                        <div className={styles.link} data-testid={`link-actions-caseform-show-all-logs`} onClick={() => {
                          history.push(`/action-time-log/${caseId}`);
                        }}>
                          Show all logs
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {(actionType?.custom || currentActionState?.typeObj?.custom) && (<>
              <Grid item xs={12} className={'Action-description-editor'}>
                <Box className={styles.info}>Description</Box>
                <ValidatedTextInput
                  autoFocus
                  placeholder="Input description there"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setInputTouched(8);
                  }}
                  onBlur={() => { if (description !== currentActionState?.description && !!caseId) doSave(); }}
                  variant="outlined"
                  name="editingName"
                  validators={['maxStringLength:85']}
                  errorMessages={['Not more then 85 characters are allowed']}
                  fullWidth
                  disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing}
                  data-testid={`validatedtextinput-actions-caseform-description`}
                />
              </Grid>
            </>)}

            {(!actionType?.hideNotes && !currentActionState?.typeObj?.hideNotes) && (
              <Grid item xs={12}>
                <Grid container justifyContent={'space-between'} alignContent={'center'} alignItems={'center'} className={styles.subtitleWrapper}>
                  <Grid item className={styles.subtitle}>Notes</Grid>
                  {isEditingNotes ? (
                    <Grid container item className={`${styles.editIconsWrapper} ${styles.up}`}>
                      <Grid item className={`${styles.icon}`}>
                        <IconButton className={`${styles.iconBtn} ${styles.linkColor}`} onClick={() => { setIsEditingNotes(false); if (!!caseId) doSave(); }} data-testid="iconbutton-actions-case-notes-save">
                          <SaveIcon />
                        </IconButton>
                      </Grid>
                      <Grid item className={`${styles.icon}`}>
                        <IconButton
                          className={`${styles.iconBtn} ${styles.linkColor}`}
                          onClick={() => { setIsEditingNotes(false); setNotesHtml(notesBeforeEditing); }}
                          data-testid="iconbutton-actions-case-notes-cancel"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container item className={styles.editIconsWrapper}>
                      <Grid item className={`${styles.icon}`}>
                        <IconButton
                          className={`${styles.iconBtn}`}
                          onClick={() => { setIsEditingNotes(true); setShouldUpdateTinyEditor(true); setNotesBeforeEditing(notesHtml); }}
                          disabled={(isEditingComment && !!caseId) || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing || isWaitingOnHoldParameters}
                          data-testid="button-actions-case-notes-edit"
                        >
                          <EditIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {isEditingNotes ? (<>
                  <EnhancedTinyMCEditor
                    state={notesHtml}
                    updateState={setNotesHtml}
                    shouldUpdate={shouldUpdateTinyEditor}
                    setShouldUpdate={setShouldUpdateTinyEditor}
                    editorTestId="mceditor-actions-caseform-notes"
                  />
                  <ValidationErrorLabel errorMessage={(notesHtml ?? '').length > MAX_NOTES_SIZE ? 'Maximum allowed size is 2 MB.' : ''} />
                </>) : notesHtml?.length ? (
                  <div className={`${styles.notesWrapper} ${styles.defaultEditor}`}>
                    <div dangerouslySetInnerHTML={createMarkup(notesHtml)} />
                  </div>
                ) : (
                  <Grid container justifyContent={'center'} justifyItems={'center'}>
                    <Grid item className={styles.emptyLabel}>No details provided</Grid>
                  </Grid>
                )}
              </Grid>
            )}

            {(!!groupedChecklist?.length) && (<>
              <Grid item xs={12}>
                <Box className={styles.info}>Checklist</Box>
                {groupedChecklist.map((group, groupIndex) => {
                  return (<React.Fragment key={groupIndex}>
                    {(group.section !== OTHER || groupIndex > 0) && (
                      <Box className={styles.sectionTitle} sx={{ mt: groupIndex > 0 ? 2 : 0 }}>{group.section}</Box>
                    )}
                    {group.items.map((item, itemIndex) => {
                      return (<Grid item container xs={12} spacing={1} key={itemIndex}>
                        <Grid item>
                          <Checkbox
                            checked={!!item.isDone}
                            onChange={() => {
                              switchIsDoneState(item.uid, groupIndex, itemIndex);
                            }}
                            size={"small"}
                            className={styles.checkbox}
                            disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || !!inProgress}
                            data-testid={`checkbox-actions-case-checklist-${groupIndex}-${itemIndex}`}
                          />
                        </Grid>
                        <Grid item className={`${styles.checkboxLabel} ${!!item.isDone ? styles.checked : ''}`}>
                          {item?.title ? item.title : 'No title'}
                        </Grid>
                      </Grid>);
                    })}
                  </React.Fragment>);
                })}
              </Grid>
            </>)}

            <Grid item xs={12}>
              <Grid container spacing={2}>
                {!!caseId && (
                  <Grid item>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      className={styles.addHistoryItemButton}
                      onClick={() => { onAddComment(); setInputTouched(9); }}
                      disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing}
                      data-testid="button-actions-case-add-comment"
                    >
                      ADD COMMENT
                    </Button>
                  </Grid>
                )}
                <Grid item>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    className={styles.addHistoryItemButton}
                    onClick={() => { onAddDocument(); setInputTouched(10); }}
                    disabled={(!!caseId && (isEditingComment || isEditingNotes || isWaitingOnHoldParameters)) || !!inProgress || isChecklistProcessing || isPropertyValuationProcessing}
                    data-testid="button-actions-case-add-document"
                  >
                    ADD DOCUMENT
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {(!!oldHistory?.length || !!newHistory?.length || isEditingComment) && (<>
              {!!isEditingComment && (
                <Grid item xs={12}>
                  <Grid container justifyContent={'space-between'} alignContent={'center'} alignItems={'center'}>
                    <Grid item className={styles.historyItemHeader}>Input comments below</Grid>
                    <Grid container item className={`${styles.editIconsWrapper}`}>
                      <Grid item className={`${styles.icon}`}>
                        <IconButton className={`${styles.iconBtn} ${styles.linkColor}`} onClick={() => { setIsEditingComment(false); onSaveComment(); }} data-testid="button-actions-case-save-comment">
                          <SaveIcon />
                        </IconButton>
                      </Grid>
                      <Grid item className={`${styles.icon}`}>
                        <IconButton
                          className={`${styles.iconBtn} ${styles.linkColor}`}
                          onClick={() => { setIsEditingComment(false); setCommentHtml(''); }}
                          data-testid="button-actions-case-cancel-comment"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                  <EnhancedTinyMCEditor
                    state={commentHtml}
                    updateState={setCommentHtml}
                    shouldUpdate={shouldUpdateCommentEditor}
                    setShouldUpdate={setShouldUpdateCommentEditor}
                    editorTestId="mceditor-actions-caseform-comment"
                  />
                  <ValidationErrorLabel errorMessage={(commentHtml ?? '').length > MAX_NOTES_SIZE ? 'Maximum allowed size is 2 MB.' : ''} />
                </Grid>
              )}

              <Grid container item xs={12}>
                <Grid item xs={12}>
                  {dimensions.isScreenBiggerSM ? (
                    <Grid container alignItems={"flex-start"} direction={"row"} justifyContent={"flex-start"}>
                      {HISTORY_FILTERS.map((f, idx) => {
                        return (
                          <Grid
                            item
                            container
                            direction={"column"}
                            alignItems={"center"}
                            className={`${styles.filterItem} ${f === historyFilter ? styles.selected : ''}`}
                            onClick={() => { setHistoryFilter(f); }}
                            key={idx}
                          >
                            <Grid item>{f}</Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Box sx={{ mt: 4 }}>
                      <FormControl variant="outlined" fullWidth>
                        <Select value={historyFilter ?? null} fullWidth SelectDisplayProps={{ 'data-testid': `select-actions-caseform-history-filters` }}>
                          {(HISTORY_FILTERS ?? []).map((f, idx) => {
                            return (
                              <MenuItem
                                value={f}
                                key={idx}
                                onClick={() => { setHistoryFilter(f); }}
                                SelectedProps={{ 'data-testid': `menuitem-actions-caseform-history-filters-option-${idx}` }}
                              >
                                <div>{f}</div>
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12}>
                  {[...(newHistory ?? [])]
                    .filter((historyItem) => historyFilter === 'COMMENTS' ? historyItem.historyItemType === 'Commented' : (historyFilter === 'DOCUMENTS' ? historyItem.historyItemType === 'Attached file' : true))
                    .reverse()
                    .map((historyItem, idx) => renderHistoryItem(historyItem, idx, true))
                  }
                  {[...(oldHistory ?? [])]
                    .filter((historyItem) => historyFilter === 'COMMENTS' ? historyItem.historyItemType === 'Commented' : (historyFilter === 'DOCUMENTS' ? historyItem.historyItemType === 'Attached file' : true))
                    .reverse()
                    .map((historyItem, idx) => renderHistoryItem(historyItem, idx, false))
                  }
                  {(historyFilter === 'COMMENTS' && !([...(newHistory ?? []), ...(oldHistory ?? [])].filter((historyItem) => historyItem.historyItemType === 'Commented'))?.length) && (
                    <Box sx={{ mt: 2 }}>
                      <Grid container justifyContent={'center'} justifyItems={'center'}>
                        <Grid item className={styles.emptyLabel}>No comments provided</Grid>
                      </Grid>
                    </Box>
                  )}
                  {(historyFilter === 'DOCUMENTS' && !([...(newHistory ?? []), ...(oldHistory ?? [])].filter((historyItem) => historyItem.historyItemType === 'Attached file'))?.length) && (
                    <Box sx={{ mt: 2 }}>
                      <Grid container justifyContent={'center'} justifyItems={'center'}>
                        <Grid item className={styles.emptyLabel}>No documents uploaded</Grid>
                      </Grid>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </>)}
          </Grid>
        </Box>
      </>);
    };

    const renderTitle = () => {
      const productCompletionErrors = getProductCompletionErrors();
      const hasProductErrors = productCompletionErrors.length > 0;

      return (<Grid container justifyContent="space-between" spacing={2} alignContent={'center'} alignItems={'center'}>
        <Grid item className={styles.fullWidthOnXS}>{!!caseId ? `Action: ${!!currentActionState?.typeObj?.name ? currentActionState.typeObj.name : ''}` : 'Create action'}</Grid>
        <Grid item className={styles.fullWidthOnXS}>
          <FormControl variant="outlined" className={`${styles.selectWrapper} ${styles.actionStatusSelector}`}>
            <Select value={actionStatus} style={{ backgroundColor: "white" }} fullWidth disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing} SelectDisplayProps={{ 'data-testid': "select-actions-case-status" }}>
              {(!caseId ? ACTIONS_STATUSES_CREATION : ACTIONS_STATUSES).map((it) => (
                <MenuItem
                  value={it}
                  onClick={() => { if (!caseId) setActionStatus(it); else updateActionStatus(it); setInputTouched(1); }}
                  key={it}
                  SelectProps={{ 'data-testid': `option-actions-case-status-${it.toLowerCase().replace(' ', '-')}` }}
                  disabled={!!inProgress || isChecklistProcessing || isPropertyValuationProcessing || ((!assignedTo || !!checklist.find((it) => !it.isDone) || hasProductErrors || (isPropertyValuationType && !hasProductAttachment(valuationDocument))) && it === 'COMPLETED')}
                >
                  <div>{it}</div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>)
    };

    return <HeaderedPageLayout
      title={null}
      aboveCardTitle={renderTitle()}
      headerTitle={'Action'}
      progress={null}
      backAction={() => returnBack()}
      backCaption={!!caseId ? 'BACK' : 'CANCEL'}
      nextAction={saveAction}
      nextCaption={'SAVE'}
      nextDisabled={nextDisabled || inProgress || isChecklistProcessing || isPropertyValuationProcessing || isEditingNotes || isEditingComment || isWaitingOnHoldParameters}
      nextHidden={!!caseId}
      inProgress={inProgress}
      noProgressBar
      noHeader
    >
      {checkIfDataLoaded() ? renderContent() : <CircularProgress size={80} className={styles.cardProgress} />}
      <ProvideElapsedTimeModal
        open={createTimeLogOpen}
        setOpen={setCreateTimeLogOpen}
        parameters={createTimeLogParameters}
        closeOnSubmit
        title={'Tracking action time'}
        description={'How much time you spent working on this action?'}
      />
      <AttachFilesModal
        journeys={undefined}
        definedJourney={undefined}
        hideJourneySelector
        documentTypes={productAttachDocumentTypes}
        setOpen={setProductAttachModalOpen}
        onUpload={handleProductDocumentUpload}
        open={productAttachModalOpen}
        isUploading={isUploading}
        currentProgress={currentProgress}
        updateDocumentsList={() => { }}
        purpose={productAttachPurpose}
        document={productAttachDocument}
        userRole={userRole}
        mustBeInternal
        limitationMode={isActionCompleted ? 'not-editable' : 'assessment_documents'}
        requiredUserNotRequired
        currentUser={journey?.user ?? user}
      />
      <AttachFilesModal
        journeys={journey ? [journey] : undefined}
        definedJourney={journey ?? undefined}
        hideJourneySelector
        documentTypes={documentTypes}
        setOpen={setOpenAttachFiles}
        onUpload={doUpload}
        open={openAttachFiles}
        isUploading={isUploading}
        currentProgress={currentProgress}
        updateDocumentsList={() => { }}
        purpose={purpose}
        document={documentToView}
        userRole={userRole}
        mustBeInternal={true}
        limitationMode={limitationMode}
        requiredUserNotRequired
      />
      <AttachFilesModal
        journeys={journey ? [journey] : undefined}
        definedJourney={journey ?? undefined}
        hideJourneySelector
        documentTypes={valuationDocumentTypes}
        setOpen={setValuationAttachModalOpen}
        onUpload={handleValuationDocumentUpload}
        open={valuationAttachModalOpen}
        isUploading={isUploading}
        currentProgress={currentProgress}
        updateDocumentsList={() => { }}
        purpose={productAttachPurpose}
        document={valuationDocument}
        userRole={userRole}
        mustBeInternal={true}
        limitationMode={isActionCompleted ? 'not-editable' : 'assessment_documents'}
        requiredUserNotRequired
        currentUser={journey?.user ?? user}
      />
      <ConfirmDeletionModal open={deleteConfirmationOpen} setOpen={setDeleteConfirmationOpen} parameters={deleteConfirmationParameters} />
    </HeaderedPageLayout>;
  };

  export default withRouter(CaseForm);

